import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import {
  ActiveCampaignInviaClientiRQ,
  ActiveCampaignInviaClientiRS,
  AggiornaFasceWelcomeRQ,
  ArchiviaPreventiviRQ,
  AssociaRisorseSistemazioneRQ,
  AssociaRisorseTariffeServizioRQ,
  AssociaTariffePianoTariffarioRQ,
  BloccaPubblicazioneAutomaticaRQ,
  CancellaOrdinePiattiMySelfRQ,
  CancellaPreventiviRQ,
  CancellaPreventivoRQ,
  CancellaPreventivoRS,
  CheckAlbergoMasterRS,
  CheckAlbergoRS,
  CheckDisponibilitaVoucherRQ,
  CheckPortaleRS,
  CheckTemplatesPrenotazioneRS,
  CheckVoucherRQ,
  CheckVoucherRS,
  CollegaTariffePortaleMasterRQ,
  ConfermaPrenotazioniWSRQ,
  ConfigurazioneAnnuncioAirbnb,
  ConfigurazioneTipoCameraAirbnb,
  CreaPrenotazioneTransazioneRQ,
  CreaPrenotazioneTransazioneRS,
  CreaPromozioneRQ,
  CreateBuonoScontoRQ,
  CreatePrenotazioneAccessoriRQ,
  DeleteBookingSolutionRQ,
  DeleteMailRQ,
  DetailListinoRS,
  DetailPromozioneRS,
  DetailServizioDmsRS,
  EliminaMessaggioRQ,
  EseguiWorkFlowPrenotazioneRQ,
  EseguiWorkFlowPrenotazioneRS,
  EseguiWorkFlowPreventivoRQ,
  EseguiWorkFlowPreventivoRS,
  Filter,
  FiltroLogDisponibilita,
  FiltroLogOperazione,
  GeneraCodiceGoogleAuthenticatorRS,
  GeneraTokenAirbnbRQ,
  GetAlberghiDashboardAdminRS,
  GetAlberghiRQ,
  GetArticoliMySelfRQ,
  GetCalendarioMenuRQ,
  GetCalendarioMenuRS,
  GetCalendarioMenuViewRQ,
  GetCalendarioMenuViewRS,
  GetCamereLibereWelcomeRQ,
  GetCamereLibereWelcomeRS,
  GetClientiRQ,
  GetCodiciPromozioneValidiRQ,
  GetCollegamentiPoliticaCancellazioneRS,
  GetConfigurazioneAnnuncioAirbnbRS,
  GetConfigurazioneMasterRS,
  GetConfigurazioneTipoCameraAirbnbRS,
  GetContatoriMenuRS,
  GetContenutiRQ,
  GetContenutiRS,
  GetCreaPagamentoViewRQ,
  GetCreaPagamentoViewRS,
  GetCreaPromozioneViewRS,
  GetDashboardAdminRQ,
  GetDetailPrenotazioneRQ,
  GetDisponibiliCrsRQ,
  GetDisponibiliCrsRS,
  GetDisponibilitaNottiRQ,
  GetDisponibilitaNottiRS,
  GetErroriDashboardAdminRS,
  GetFunzionalitaPortaliRS,
  GetGiorniDaPubblicareRQ,
  GetImpostazioniMySelfViewRS,
  GetImpostazioniViewRS,
  GetInfoDashboardRS,
  GetMailRQ,
  GetMailRS,
  GetMenuFilterRS,
  GetMenuRS,
  GetMessaggiRQ,
  GetModalitaPagamentoGestPayRQ,
  GetModificaBlocchiFormRS,
  GetMySelfConfigRQ,
  GetMySelfConfigRS,
  GetNazioneTradottaRQ,
  GetNazioniTradotteRQ,
  GetNotificheEmailDashboardAdminRS,
  GetNotificheEmailDashboardRS,
  GetNumeroPreventiviDashboardAdminRS,
  GetNumeroSondaggiDashboardAdminRS,
  GetPagamentoFormViewRQ,
  GetPagamentoFormViewRS,
  GetPagineDmsRQ,
  GetPasswordClienteRQ,
  GetPlanningDisponibilitaCrsRQ,
  GetPlanningDisponibilitaCrsRS,
  GetPortaliDashboardAdminRS,
  GetPrenotazioneDetailsMySelfRQ,
  GetPrenotazioneDetailsMySelfRS,
  GetPrenotazioniAssociateRS,
  GetPrenotazioniDashboardAdminRS,
  GetPreventiviClienteRQ,
  GetPreventiviRQ,
  GetPrezzoListinoPrenotazioneAccessoriWelcomeRQ,
  GetPrezzoListinoPrenotazioneAccessoriWelcomeRS,
  GetPrezzoMinimoBookingV2RS,
  GetPrivacyPortaleRS,
  GetPromozioniViewRS,
  GetQuadroGraficoAccessoriWelcomeRQ,
  GetQuadroGraficoAccessoriWelcomeRS,
  GetQuantitaMassimaGiornalieraSupplementiWelcomeRQ,
  GetQuantitaMassimaGiornalieraSupplementiWelcomeRS,
  GetQuantitaMassimaGiornalieraSupplementoWelcomeRQ,
  GetQuantitaMassimaGiornalieraSupplementoWelcomeRS,
  GetRecensioniRQ,
  GetRicercheRQ,
  GetRicercheRS,
  GetRichiesteFilterRS,
  GetRichiesteRQ,
  GetRichiesteRS,
  GetRisorseNonAttiveSistemazioneRQ,
  GetRisorseTariffeNonAttiveServizioRQ,
  GetRisorseTariffeNonAttiveServizioRS,
  GetRisorseTariffePromozioniCollegateSupplementoRS,
  GetServiziRQ,
  GetStampaPrenotazioneFormWelcomeRQ,
  GetStampaPrenotazioneFormWelcomeRS,
  GetStatoPubblicazionePortaliRQ,
  GetStoricoPrenotazioneRQ,
  GetStoricoRQ,
  GetStoricoRS,
  GetTagsTemplateRQ,
  GetTariffePianoTariffarioRQ,
  GetTariffePianoTariffarioRS,
  GetTemplateConfigurazionePortaleRQ,
  GetTemplateConfigurazionePortaleRS,
  GetTransazioneByIdRQ,
  GetTransazioniDashboardAdminRS,
  GetTransazioniRQ,
  GetTrasferisciPrenotazioniViewRQ,
  GetTrasferisciPrenotazioniViewRS,
  GetUnsubscribeRQ,
  GetUnsubscribeRS,
  GetVariazioniTassaRS,
  GetVersioneBookingEngineRQ,
  GetVoucherConfigRQ,
  GetVoucherConfigRS,
  HubSpotInviaClientiRQ,
  HubSpotInviaClientiRS,
  ImportaRisorseRQ,
  ImportaRisorseRS,
  ImportaTariffeRQ,
  ImportaTariffeRS,
  ImpostaDaLeggereMessaggioRQ,
  ImpostaLettoMessaggioRQ,
  ImpostaModalitaPagamentoPrenotazioneRQ,
  InviaEmailPortaleRQ,
  InviaEmailPortaleRS,
  InviaMessaggioPreventiviRQ,
  LoginUtenteRQ,
  MailchimpInviaClientiRQ,
  MailchimpInviaClientiRS,
  ModificaMultiplaMenuGiorniRQ,
  MoveMailRQ,
  OrdinaPiattiMySelfRQ,
  PaymentModel,
  PhilipsCMNDInviaPrenotazioniRQ,
  PhilipsCMNDInviaPrenotazioniRS,
  PlanningMasterRQ,
  PlanningMasterRS,
  PreventiviViewRS,
  PubblicaDisponibilitaGiornoRQ,
  RecuperaPasswordAPIRQ,
  RecuperaPrenotazioniRQ,
  RecuperaPrenotazioniRS,
  RegistraClienteRQ,
  RicalcolaPropostePreventivoRQ,
  RifiutaPreventivoMyPageRQ,
  SbloccaClientiRQ,
  SbloccaPubblicazioneAutomaticaRQ,
  ScrollideaInviaPrenotazioniRQ,
  ScrollideaInviaPrenotazioniRS,
  SendMailRQ,
  SendMailRS,
  SetAnnuncioAirbnbRS,
  SetCategoriePiattiXLinguaRQ,
  SetCausaliOperazioneXLinguaRQ,
  SetComponentiXVariazioneXLinguaRQ,
  setDatiCheckInMultipleRQ,
  setDatiCheckInRQ,
  SetErroreEsaminatoRQ,
  SetEventiXLinguaRQ,
  SetImmaginePaginaMySelfRQ,
  SetImmaginePaginaMySelfRS,
  SetImmaginePiattoMySelfRQ,
  SetImmaginePiattoMySelfRS,
  SetImmagineUbicazioneIstatRQ,
  SetImmagineUbicazioneIstatRS,
  SetMailAsSeenRQ,
  SetMenuXLinguaRQ,
  SetMotiviViaggioXLinguaRQ,
  SetNazioniXLinguaRQ,
  SetPagineAlbergoMasterXLinguaRQ,
  SetPiattiXLinguaRQ,
  SetRisorseXLinguaRQ,
  SetUbicazioniIstatXLinguaRQ,
  SetVariazioniXPeriodoPortaleMasterRQ,
  StampaPrenotazioneWelcomeRQ,
  StampaPrenotazioneWelcomeRS,
  TestConnectionRQ,
  TestConnectionRS,
  TipiClienteViewRS,
  TrasferisciPrenotazioniRQ,
  TrustyouInviaPrenotazioniRQ,
  TrustyouInviaPrenotazioniRS,
  UpdateDettagliFromBookingSolutionRQ,
  UpdateFromDisponibiliHotelRQ,
  UpdatePromozioneRQ,
  UpdatePromozioneRS,
  VerificaCodiceMasterRQ,
  VerificaCodicePromozioneBookingRQ,
  VerificaPinGoogleAuthenticatorRQ,
  ViewFascia,
  WelcomeEseguiWorkFlowsRQ,
  WelcomeServerAuthenticateRQ,
  WelcomeServerAuthenticateRS,
  WelcomeServerRequest,
  WorkFlowsViewRS,
} from 'src/app/shared/models/dto';
import { SessionService } from 'src/app/shared/services/session.service';
import { environment } from 'src/environments/environment';

import {
  AccountMail,
  Agenzia,
  Albergo,
  AlbergoApiKeys,
  AlbergoCrs,
  AlbergoMasterImmagini,
  Allegato,
  Arrotondamento,
  BackgroundWorker,
  BookingRules,
  ChangeLog,
  Cliente,
  ClienteAppuntamenti,
  Comune,
  Dashboard,
  DisponibilitaXPortaleXAlbergo,
  ImmagineXTipoCameraOTA,
  Interesse,
  Listino,
  MessaggioExtranet,
  Portale,
  PortaleParametri,
  PortaleXAlbergo,
  PortaleXAlbergoCancellazioniOTA,
  PortaleXAlbergoFiltri,
  PortaleXAlbergoImmagini,
  PortaleXAlbergoServiziOTA,
  PortaleXAlbergoVariazioni,
  Prenotazione,
  PrenotazioneConteggioPiatti,
  PrenotazioneExtra,
  PrenotazioneUpSelling,
  Preventivo,
  PreventivoCamereProposte,
  PreventivoCamereProposteDettagli,
  QuadroGrafico,
  ReportHotel,
  Richiesta,
  RisorsaImmagini,
  SondaggioRisposta,
  SorgenteRichiesta,
  SourceBrandXAgenzia,
  TagCrm,
  TagCrmImmagini,
  TagCrmXLingua,
  TariffaOTA,
  TariffaOTADerivata,
  TariffaOTAXTipoCameraOTA,
  TemplateTags,
  TipoCameraOTACalendar,
  TipoCameraOTAUpgrade,
  TipoCameraOTAXComponente,
  TipoCartaCreditoXAlbergo,
  TipoCliente,
  Transazione,
  UbicazioneIstat,
  UbicazioneIstatCss,
  UbicazioneIstatMenu,
  UbicazioneIstatXLingua,
  Utente,
  VideoTutorial,
  WebHooks,
  WorkFlow,
} from '../models/bo.model';
import {
  AccettaPreventivoRQ,
  AuthenticateAlbergoRQ,
  AuthenticateAlbergoRS,
  AuthenticateMySelfRQ,
  AuthenticateMySelfRS,
  BookingExtraSolutionRQ,
  BookingExtraSolutionRS,
  BookingSolutionConfigRQ,
  BookingSolutionConfigRS,
  BookingSolutionRQ,
  BookingSolutionRS,
  BookingSolutionsRS,
  CalendarioFasceFormRQ,
  CalendarioFasceFormRS,
  CheckDisponibilitaFuturePubblicateRQ,
  CheckTokenRQ,
  CheckTokenRS,
  ConfermaPreventivoRQ,
  CopiaDisponibilitaRQ,
  CreaPrenotazioneExtraRQ,
  CreaPrenotazioneExtraRS,
  CreaPreventivoRQ,
  CreaPreventivoRS,
  CreaProposteRQ,
  CreaRichiestaPreventivoRQ,
  CreaRichiestaPreventivoRS,
  CreaRichiestaRQ,
  CreaRichiestaRS,
  CreatePrenotazioneExtraRQ,
  CreatePrenotazioneRQ,
  CreatePrenotazioneRS,
  DashboardHotelRS,
  DashboardRQ,
  DeleteAllProposteRQ,
  DetailAlbergoMasterRS,
  DetailClienteRS,
  DetailCodicePromozioneRS,
  DetailPrenotazioneRS,
  DetailRichiestaRS,
  DettagliPortaleRQ,
  DettagliPortaleRS,
  DmsSolutionRQ,
  DmsSolutionRS,
  DuplicaPropostaRS,
  EmettiVoucherRQ,
  GeneraOpzioniRQ,
  GeneraOpzioniRS,
  GetArrotondamentiFilterRS,
  GetArrotondamentiRS,
  GetCalendarioDisponibilitaCamereRQ,
  GetCalendarioDisponibilitaCamereRS,
  GetCancellazioniFilterRS,
  GetCancellazioniRS,
  GetChiusureGiornaliereDashboardRS,
  GetClientiProfilatiRQ,
  GetClientiProfilatiRS,
  GetCodiciPromozioneViewRS,
  GetDashboardRQ,
  GetDisponibilitaDashboardRS,
  GetDisponibilitaPrezziDashboardRS,
  GetDisponibilitaRQ,
  GetDisponibilitaRS,
  GetFasciaRQ,
  GetFormV1ViewRQ,
  GetFormV1ViewRS,
  GetImmaginiPortaliServiziXAlbergoMasterRQ,
  GetImmaginiPortaliServiziXAlbergoMasterRS,
  GetLogOperazioneDettagliRQ,
  GetLogOperazioneDettagliRS,
  GetModalitaPagamentoDefaultRQ,
  GetMyPageRQ,
  GetMyPageRS,
  GetMySelfBookingRQ,
  GetMySelfBookingRS,
  GetMySelfRQ,
  GetMySelfRS,
  GetOfferRQ,
  GetOfferRS,
  GetPayMailRQ,
  GetPayMailRS,
  GetPianiTariffariFilterRS,
  GetPianiTariffariRS,
  GetPortaleXAlbergoFormRS,
  GetPortaleXAlbergoRS,
  GetPortaliViewRS,
  GetPortaliXAlbergoXLinguaRS,
  GetPrenotazioniDashboardRS,
  GetPrenotazioniExtraFilterRS,
  GetPrenotazioniExtraRS,
  GetPrenotazioniFilterRS,
  GetPrenotazioniRS,
  GetPreventiviDashboardRS,
  GetPreventivoRS,
  GetPrezziRS,
  GetPrezzoArticoloRQ,
  GetPrezzoArticoloRS,
  GetPrezzoMinimoRQ,
  GetPrivacyPortaleRQ,
  GetRoomingListRQ,
  GetRoomingListRS,
  GetSondaggioPrenotazioneRQ,
  GetSondaggioPrenotazioneRS,
  GetSondaggiXLinguaRS,
  GetStatiPreventiviRQ,
  GetStatiPreventiviRS,
  GetTagCrmViewRS,
  GetTariffeCollegateRQ,
  GetTariffeCollegateRS,
  GetTemplatesRS,
  GetTipoCameraOTARS,
  GetTotaliPrenotazioniDashboardRS,
  GetTrattamentiFilterRS,
  GetTrattamentiRS,
  GetUpSellingViewRS,
  GetUtentiFilterRS,
  GetUtentiRS,
  InviaEmailClienteRQ,
  InviaEmailClienteRS,
  InviaEmailPrenotazioneRQ,
  InviaEmailPrenotazioneRS,
  InviaEmailTransazioneRQ,
  InviaEmailTransazioneRS,
  InviaEmailVoucherRQ,
  InviaEmailVoucherRS,
  InviaPreventivoRQ,
  InviaPreventivoRS,
  PaymentRQ,
  PaymentRS,
  PlanningRQ,
  PlanningRS,
  PrenotaPreventivoRQ,
  PrenotaPreventivoRS,
  PubblicaDerivedPricesRQ,
  PubblicaDerivedPricesRS,
  PubblicaDisponibilitaRQ,
  PubblicaDisponibilitaRS,
  QualitelisInviaPrenotazioniRQ,
  QualitelisInviaPrenotazioniRS,
  RecuperaPasswordRQ,
  RecuperaPasswordRS,
  ReplaceTagsTemplateRQ,
  ReplaceTagsTemplateRS,
  RequestPickupPreventiviRQ,
  RequestPickupPreventiviRS,
  RequestPickupRQ,
  RequestPickupRS,
  RichiediCancellazionePrenotazioneRQ,
  RichiediUpSellingPrenotazioneRQ,
  RichiediUpSellingPrenotazioneRS,
  RifiutaPreventivoRQ,
  RifiutaPreventivoRS,
  RifiutaRichiestaRQ,
  RifiutaRichiestaRS,
  RinnovaRichiestaRQ,
  RisorseRQ,
  RisorseRS,
  SalvaFasceRQ,
  SalvaFasceRS,
  SendMessageClienteRQ,
  SendMessagePrenotazioneRQ,
  SendMessagePreventivoRQ,
  SendMessageTransazioneRQ,
  SendSmsRQ,
  SendSmsRS,
  SendTestEmailRS,
  SetAlberghiMasterXLinguaRQ,
  SetArticoliXLinguaRQ,
  SetBannerXLinguaRQ,
  SetBlocchiHtmlXLinguaRQ,
  SetCancellazioniXLinguaRQ,
  SetCodiciPromozioneXLinguaRQ,
  SetImmagineAlbergoMasterRQ,
  SetImmagineAlbergoMasterRS,
  SetImmagineArticoloRQ,
  SetImmagineArticoloRS,
  SetImmagineEventoRQ,
  SetImmagineEventoRS,
  SetImmaginePortaleAdminRQ,
  SetImmaginePortaleAdminRS,
  SetImmaginePortaleRQ,
  SetImmaginePortaleRS,
  SetImmaginePromozioneRQ,
  SetImmaginePromozioneRS,
  SetImmagineServizioRQ,
  SetImmagineServizioRS,
  SetImmagineSistemazioneRQ,
  SetImmagineSistemazioneRS,
  SetImmagineSupplementoRQ,
  SetImmagineSupplementoRS,
  SetImmagineTagCrmRQ,
  SetImmagineTagCrmRS,
  SetImmagineTemplateRQ,
  SetImmagineTemplateRS,
  SetImmagineTipoCameraRQ,
  SetImmagineTipoCameraRS,
  SetImmagineTutorialRQ,
  SetImmagineTutorialRS,
  SetImmagineUtenteRQ,
  SetImmagineUtenteRS,
  SetImmagineVoceAddebitoRQ,
  SetImmagineVoceAddebitoRS,
  SetModalitaPagamentoXLinguaRQ,
  SetMySelfPagesXLinguaRQ,
  SetParametriRicercaXLinguaRQ,
  SetPortaliXLinguaRQ,
  SetRecensioniXLinguaRQ,
  SetRiduzioniXLinguaRQ,
  SetServiziDmsXLinguaRQ,
  SetServiziXLinguaRQ,
  SetSistemazioniXLinguaRQ,
  SetSondaggiXLinguaRQ,
  SetSupplementiXLinguaRQ,
  SetTagCrmXLinguaRQ,
  SetTariffeOTAXLinguaRQ,
  SetTemplatesXLinguaRQ,
  SetTipiCameraOTAXLinguaRQ,
  SetTipiCameraXLinguaRQ,
  SetTipiCarteCreditoRQ,
  SetTransazioneRQ,
  SetTrattamentiXLinguaRQ,
  SetUpSellingXLinguaRQ,
  SetVociAddebitoXLinguaRQ,
  SincronizzaDisponibilitaRQ,
  TariffeRQ,
  TariffeRS,
  TestMailRQ,
  TrentinoAttivaDisattivaCartaRQ,
  TrentinoAttivaDisattivaCartaRS,
  TrentinoEmettiCartaRQ,
  TrentinoEmettiCartaRS,
  TrentinoGetTipiCarteRQ,
  TrentinoGetTipiCarteRS,
  TrentinoLeggiCarteRQ,
  TrentinoLeggiCarteRS,
  TrentinoModificaCartaRQ,
  TrentinoModificaCartaRS,
  UpdateAllDisponibilitaRQ,
  UpdateDisponibilitaRQ,
  UpdatePaxPreventivoRQ,
  UpdatePaxRichiestaRQ,
  UpdatePermessiRQ,
  UpdatePianoTariffarioRQ,
  UpdatePrezziRQ,
  UpdateTotalsPreventivoRQ,
  VerificaCartaCreditoRQ,
  VerificaCartaCreditoRS,
  VerificaCodicePromozioneRQ,
  VerificaCodicePromozioneRS,
  VerificaVoucherRQ,
  VerificaVoucherRS,
  ViewPreventivoRQ,
  WebApiRequestFilter,
  WebApiRequestViewSelect,
  WebApiResponse,
  WebApiResponseFilter,
  WebApiResponseUpdate,
  WebApiResponseUpdateDetails,
  WorkFlowDetailRS,
} from '../models/dto';
import { CriteriaOperator, FilterValueType, TestoMyPage } from '../models/enum';
import { LocalizationService } from './localization.service';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private errorDialogOpen: boolean = false;

  constructor(private http: HttpClient,
    private sessionService: SessionService,
    private utility: UtilityService,
    private localizationService: LocalizationService) { }

  showError(error: string, generic: boolean = false) {
    if (!!error && !this.errorDialogOpen) {
      let promise: Promise<any>;

      if (generic) {
        promise = this.utility.showError('globals.messages.genericError', { errore: error });
      } else {
        promise = this.utility.showError(error);
      }

      if (promise != null) {
        this.errorDialogOpen = true;
        promise.then(() => this.errorDialogOpen = false);
      }
    }
  }

  get<T>(operationName: string, showError: boolean = true, headers?: HttpHeaders): Observable<T> {
    return this.executeRequest(operationName, null, showError, false, headers);
  }

  post<T, X>(operationName: string, rq: X, showError: boolean = true, headers?: HttpHeaders): Observable<T> {
    return this.executeRequest(operationName, rq, showError, true, headers);
  }

  private executeRequest<T, X>(operationName: string, rq: X, showError: boolean, isPost: boolean, headers?: HttpHeaders): Observable<T> {
    let url: string = environment.backendUrl + '/' + operationName;

    if (headers == null && this.sessionService.isAttachRequestHeaders) {
      let currentUser = this.sessionService && this.sessionService.sessione ? this.sessionService.sessione.utente : null;
      let oidAlbergo = this.sessionService != null ? this.sessionService.getOidAlbergo().toString() : '';
      let token = this.sessionService && this.sessionService.sessione ? this.sessionService.sessione.token : null;

      let apiKey = this.sessionService != null ? this.sessionService.getApiKeyAlbergo() : '';
      let userKey = this.sessionService != null ? this.sessionService.getApiKeyUtente() : '';
      let customerKey = this.sessionService != null ? this.sessionService.getApiKeyCustomer() : '';
      let username = currentUser != null ? currentUser.username : '';
      let codicePartner = currentUser != null && currentUser.codicePartner != null ? currentUser.codicePartner : '';

      if (token != null) {
        headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
          'X-Albergo': oidAlbergo,
          'X-ApiKey': apiKey,
          'X-UserKey': userKey,
          'X-CustomerKey': customerKey,
          'X-UserName': username,
          'X-CodicePartner': codicePartner
        });
      }
    }

    return (isPost ? this.http.post<T>(url, rq, { headers: headers }) : this.http.get<T>(url, { headers: headers })).pipe(
      retry({
        count: 2, delay: (error: HttpErrorResponse) => {
          if (error.status == 0) {
            return timer(1000);
          }

          throw error;
        }
      }),
      tap((res: T) => {
        if (res != null && res['errori'] != null && res['errori'].length > 0 && showError) {
          this.utility.setIsLoading(false);
          this.showError(this.localizationService.getTranslationFromErrori(res['errori']));
        }
      }),
      catchError(err => {
        let error: any;

        if (err.status == 0) {
          error = this.localizationService.getTranslationSync('globals.messages.networkIssue0');
        } else if (err.status == 400) {
          error = this.localizationService.getTranslationSync('globals.messages.badRequest400');

          if (err.error && err.error.data && err.error.data instanceof Array) {
            let cause = err.error.data[0];
            error += '<br/>' + cause;
          }
        } else if (err.status == 401) {
          this.sessionService.clearSessione();
          window.location.href = '/sbm';
          error = this.localizationService.getTranslationSync('globals.messages.unauthorized401');
        } else if (err.status == 403) {
          error = this.localizationService.getTranslationSync('globals.messages.genericAuthError');
        } else if (err.status == 404) {
          error = this.localizationService.getTranslationSync('globals.messages.notFound404');
        } else if (err.status == 504) {
          error = this.localizationService.getTranslationSync('globals.messages.badGateway504');
        } else if (err.status == 500) {
          error = this.localizationService.getTranslationSync('globals.messages.erroreInternoServer500');
        } else if (err.error) {
          error = err.error;
        } else if (err.message) {
          error = err.message;
        } else {
          error = err;
        }

        if (showError) {
          this.utility.setIsLoading(false);
          this.showError(error, true);
        }

        return throwError(() => error);
      })
    );
  }

  checkAlbergo(oid: number): Observable<CheckAlbergoRS> {
    return this.get('Albergo/' + oid + '/Check');
  }

  getAlbergo(oid: number): Observable<WebApiResponse> {
    return this.get('Albergo/' + oid);
  }

  getContatoriMenu(): Observable<GetContatoriMenuRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/GetContatoriMenu');
  }

  authenticate(rq: AuthenticateAlbergoRQ): Observable<AuthenticateAlbergoRS> {
    return this.post('Utenti/Authenticate', rq);
  }

  checkToken(rq: CheckTokenRQ): Observable<CheckTokenRS> {
    return this.post('Albergo/CheckToken', rq);
  }

  creaAlbergo(rq: Albergo): Observable<WebApiResponse> {
    return this.post('Albergo/CreaAlbergo', rq);
  }

  authenticateMySelf(rq: AuthenticateMySelfRQ): Observable<AuthenticateMySelfRS> {
    return this.post('Clienti/AuthenticateMySelf', rq);
  }

  getPagineMySelf(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/PagineMySelf');
  }

  getPagineMySelfFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/PagineMySelf/Filter', rq);
  }

  getPaginaMySelf(oid: number): Observable<WebApiResponse> {
    return this.get('MySelfConfigurazione/Pagina/' + oid);
  }

  getPagineMySelfXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('MySelfConfigurazione/PagineXLingua/Filter', WebApiRequestFilter.fromFilter('mySelfPage.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setPaginaMySelf(rq: SetMySelfPagesXLinguaRQ): Observable<WebApiResponse> {
    return this.post('MySelfConfigurazione/UpdatePagina', rq);
  }

  getPiatti(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Piatti');
  }

  getPiattiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Piatti/Filter', rq);
  }

  getPiatto(oid: number): Observable<WebApiResponse> {
    return this.get('MySelfConfigurazione/Piatto/' + oid);
  }

  getPiattiXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('MySelfConfigurazione/PiattiXLingua/Filter', WebApiRequestFilter.fromFilter('piatto.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setPiatto(rq: SetPiattiXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('MySelfConfigurazione/UpdatePiatto', rq);
  }

  getCategoriePiatti(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/CategoriePiatti');
  }

  getCategoriePiattiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/CategoriePiatti/Filter', rq);
  }

  getCategoriaPiatto(oid: number): Observable<WebApiResponse> {
    return this.get('MySelfConfigurazione/CategoriaPiatto/' + oid);
  }

  getCategoriePiattiXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('MySelfConfigurazione/CategoriePiattiXLingua/Filter', WebApiRequestFilter.fromFilter('categoriaPiatto.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setCategoriaPiatto(rq: SetCategoriePiattiXLinguaRQ): Observable<WebApiResponse> {
    return this.post('MySelfConfigurazione/UpdateCategoriaPiatto', rq);
  }

  getMenuXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('MySelfConfigurazione/MenuXLingua/Filter', WebApiRequestFilter.fromFilter('menu.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setMenu(rq: SetMenuXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('MySelfConfigurazione/UpdateMenu', rq);
  }

  getLingue(): Observable<WebApiResponse> {
    return this.get('Lingue');
  }

  getNazioni(): Observable<WebApiResponse> {
    return this.get('Nazioni');
  }

  getNazioniFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Nazioni/Filter', rq);
  }

  getNazioniXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('Nazioni/NazioniXLingua/Filter', WebApiRequestFilter.fromFilter('nazione.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setNazione(rq: SetNazioniXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('Nazioni/Update', rq);
  }

  getNazioniTradotte(rq: GetNazioniTradotteRQ): Observable<WebApiResponseFilter> {
    return this.post('Nazioni/NazioniTradotte', rq);
  }

  getNazioneTradotta(rq: GetNazioneTradottaRQ): Observable<WebApiResponse> {
    return this.post('Nazioni/NazioneTradotta', rq);
  }

  getTraduzioniNazione(oid: number): Observable<WebApiResponse> {
    return this.get('Nazioni/' + oid + '/TraduzioniNazione');
  }

  getRegioni(): Observable<WebApiResponse> {
    return this.get('Regioni');
  }

  getRegioniFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Regioni/Filter', rq);
  }

  getTipoCamera(oid: number): Observable<WebApiResponse> {
    return this.get('TipiCamere/' + oid);
  }

  getRisorsa(oid: number): Observable<WebApiResponse> {
    return this.get('Risorse/' + oid);
  }

  getImmaginiRisorsa(oid: number): Observable<WebApiResponse> {
    return this.get('Risorse/' + oid + '/Immagini');
  }

  checkRisorseTipoCamera(oid: number): Observable<WebApiResponse> {
    return this.get('TipiCamere/' + oid + '/CheckRisorse');
  }

  getTipiCamera(oidAlbergo?: number): Observable<WebApiResponse> {
    return this.get('Albergo/' + (oidAlbergo == null ? this.sessionService.getOidAlbergo() : oidAlbergo) + '/TipiCamere');
  }

  getTemplate(oid: number): Observable<WebApiResponse> {
    return this.get('Templates/' + oid);
  }

  setTemplate(rq: SetTemplatesXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('Templates/Update', rq);
  }

  setAllegato(rq: Allegato): Observable<WebApiResponseUpdate> {
    return this.post('Templates/UpdateAllegato', rq);
  }

  replaceTagsTemplate(rq: ReplaceTagsTemplateRQ): Observable<ReplaceTagsTemplateRS> {
    return this.post('Templates/ReplaceTags', rq);
  }

  getTemplates(): Observable<GetTemplatesRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Templates');
  }

  getTemplatesFilter(rq: WebApiRequestFilter, oidAlbergo?: number): Observable<GetTemplatesRS> {
    return this.post('Albergo/' + (oidAlbergo != null ? oidAlbergo : this.sessionService.getOidAlbergo()) + '/Templates/Filter', rq);
  }

  getTemplatesXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('Templates/TemplatesXLingua/Filter', WebApiRequestFilter.fromFilter('template.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  getTemplatesAdmin(): Observable<GetTemplatesRS> {
    return this.get('Admin/Templates');
  }

  getTemplatesAdminFilter(rq: WebApiRequestFilter): Observable<GetTemplatesRS> {
    return this.post('Admin/Templates/Filter', rq);
  }

  getTagsTemplates(): Observable<WebApiResponse> {
    return this.get('Admin/TagsTemplates');
  }

  getTagsTemplatesFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Admin/TagsTemplates/Filter', rq);
  }

  setTagTemplate(rq: TemplateTags): Observable<WebApiResponseUpdate> {
    return this.post('Admin/UpdateTagTemplate', rq);
  }

  getChangeLogs(): Observable<WebApiResponse> {
    return this.get('Admin/ChangeLogs');
  }

  getChangeLogsFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Admin/ChangeLogs/Filter', rq);
  }

  setChangeLog(rq: ChangeLog): Observable<WebApiResponseUpdate> {
    return this.post('Admin/UpdateChangeLog', rq);
  }

  getChangeLog(): Observable<WebApiResponse> {
    return this.get('Admin/ChangeLog');
  }

  getFunzionalitaPortali(): Observable<GetFunzionalitaPortaliRS> {
    return this.get('Admin/GetFunzionalitaPortali');
  }

  setFunzionalitaPortale(rq: PortaleParametri): Observable<WebApiResponseUpdate> {
    return this.post('Admin/SetFunzionalitaPortale', rq);
  }

  getServiziAdmin(): Observable<GetTemplatesRS> {
    return this.get('Admin/Servizi');
  }

  getServiziAdminFilter(rq: WebApiRequestFilter): Observable<GetTemplatesRS> {
    return this.post('Admin/Servizi/Filter', rq);
  }

  getSondaggiAdmin(): Observable<WebApiResponse> {
    return this.get('Admin/Sondaggi');
  }

  getSondaggiAdminFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Admin/Sondaggi/Filter', rq);
  }

  getVideoTutorial(): Observable<WebApiResponse> {
    return this.get('Admin/Tutorial');
  }

  getVideoTutorialFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Admin/Tutorial/Filter', rq);
  }

  getTransazioni(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Transazioni');
  }

  getTransazioniFilter(rq: GetTransazioniRQ): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Transazioni/Filter', rq);
  }

  getNotificheEmail(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/NotificheEmail');
  }

  getNotificheEmailFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/NotificheEmail/Filter', rq);
  }

  getUbicazioniIstatCss(oidAlbergo?: number): Observable<WebApiResponse> {
    return this.get('Albergo/' + (oidAlbergo != null ? oidAlbergo : this.sessionService.getOidAlbergo()) + '/UbicazioniIstatCss');
  }

  getUbicazioniIstatCssFilter(rq: WebApiRequestFilter, oidAlbergo?: number): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + (oidAlbergo != null ? oidAlbergo : this.sessionService.getOidAlbergo()) + '/UbicazioniIstatCss/Filter', rq);
  }

  setUbicazioniIstatCss(rq: UbicazioneIstatCss[]): Observable<WebApiResponse> {
    return this.post('UbicazioniIstatCss/Update', rq);
  }

  getTipiCameraFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/TipiCamere/Filter', rq);
  }

  getTipiCameraXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('TipiCamere/TipiCameraXLingua/Filter', WebApiRequestFilter.fromFilter('tipoCamera.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setTipoCamera(rq: SetTipiCameraXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('TipiCamere/Update', rq);
  }

  getRisorse(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Risorse');
  }

  getRisorseFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Risorse/Filter', rq);
  }

  getRisorseXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('Risorse/RisorseXLingua/Filter', WebApiRequestFilter.fromFilter('risorsa.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setRisorsa(rq: SetRisorseXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('Risorse/Update', rq);
  }

  getTagCrm(oid: number): Observable<WebApiResponse> {
    return this.get('TagCrm/' + oid);
  }

  getTagCrmList(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/TagCrm');
  }

  getTagCrmFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/TagCrm/Filter', rq);
  }

  getTagCrmXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('TagCrm/TagCrmXLingua/Filter', WebApiRequestFilter.fromFilter('tagCrm.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  getTagXLingua(oid: number, lingua: string, testoMyPage: TestoMyPage): Observable<WebApiResponseFilter> {
    return this.post('TagCrm/TagCrmXLingua/Filter', WebApiRequestFilter.fromFilters([new Filter('tagCrm.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number), new Filter('lingua.codice', CriteriaOperator.Equal, lingua, FilterValueType.String), new Filter('testoMyPage', CriteriaOperator.Equal, testoMyPage.toString(), FilterValueType.Number)]));
  }

  setTagCrm(rq: SetTagCrmXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('TagCrm/Update', rq);
  }

  updateTagCrm(rq: TagCrm): Observable<WebApiResponseUpdate> {
    return this.post('TagCrm/UpdateTagCrm', rq);
  }

  setTagCrmXLingua(rq: TagCrmXLingua[]): Observable<WebApiResponse> {
    return this.post('TagCrm/UpdateTagCrmXLingua', rq);
  }

  getVoceAddebito(oid: number): Observable<WebApiResponse> {
    return this.get('VociAddebito/' + oid);
  }

  getVociAddebito(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/VociAddebito');
  }

  getVociAddebitoFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/VociAddebito/Filter', rq);
  }

  getVociAddebitoXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('VociAddebito/VociAddebitoXLingua/Filter', WebApiRequestFilter.fromFilter('voceAddebito.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setVoceAddebito(rq: SetVociAddebitoXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('VociAddebito/Update', rq);
  }

  getServizio(oid: number): Observable<WebApiResponse> {
    return this.get('Servizi/' + oid);
  }

  getServizi(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Servizi');
  }

  getServiziFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Servizi/Filter', rq);
  }

  getServiziXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('Servizi/ServiziXLingua/Filter', WebApiRequestFilter.fromFilter('servizio.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setServizio(rq: SetServiziXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('Servizi/Update', rq);
  }

  setVideoTutorial(rq: VideoTutorial): Observable<WebApiResponseUpdate> {
    return this.post('VideoTutorial/Update', rq);
  }

  getTutorials(): Observable<WebApiResponse> {
    return this.get('VideoTutorial/Tutorials');
  }

  checkPortale(oid: number): Observable<CheckPortaleRS> {
    return this.get('Portali/' + oid + '/Check');
  }

  getPortale(oid: number): Observable<GetPortaleXAlbergoRS> {
    return this.get('Portali/' + oid);
  }

  getPortali(oidAlbergo?: number): Observable<WebApiResponse> {
    return this.get('Albergo/' + (oidAlbergo != null ? oidAlbergo : this.sessionService.getOidAlbergo()) + '/Portali');
  }

  getPortaliView(): Observable<GetPortaliViewRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/PortaliView');
  }

  getCreaPromozioneView(): Observable<GetCreaPromozioneViewRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/CreaPromozioneView');
  }

  getCodiciPromozioneView(): Observable<GetCodiciPromozioneViewRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/CodiciPromozioneView');
  }

  getPromozioniView(): Observable<GetPromozioniViewRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/PromozioniView');
  }

  getPreventiviView(): Observable<PreventiviViewRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/PreventiviView');
  }

  getWorkFlowsView(): Observable<WorkFlowsViewRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/WorkFlowsView');
  }

  getUpSellingView(): Observable<GetUpSellingViewRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/UpSellingView');
  }

  getTagCrmView(): Observable<GetTagCrmViewRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/TagCrmView');
  }

  getImpostazioniMySelfView(): Observable<GetImpostazioniMySelfViewRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ImpostazioniMySelfView');
  }

  getImpostazioniView(): Observable<GetImpostazioniViewRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ImpostazioniView');
  }

  getCreaPagamentoView(rq: GetCreaPagamentoViewRQ): Observable<GetCreaPagamentoViewRS> {
    return this.post('Albergo/CreaPagamentoView', rq);
  }

  getPortaliFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Portali/Filter', rq);
  }

  getDisponibilitaAlbergo(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Disponibilita');
  }

  getDisponibilitaAlbergoFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Disponibilita/Filter', rq);
  }

  getPortaliXLingua(oid: number): Observable<GetPortaliXAlbergoXLinguaRS> {
    return this.post('Portali/PortaliXLingua/Filter', WebApiRequestFilter.fromFilter('portaleXAlbergo.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  updatePortale(rq: PortaleXAlbergo): Observable<WebApiResponseUpdate> {
    return this.post('Portali/UpdatePortale', rq);
  }

  setPortale(rq: SetPortaliXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('Portali/Update', rq);
  }

  setSourceBrand(rq: SourceBrandXAgenzia): Observable<WebApiResponseUpdate> {
    return this.post('Portali/UpdateSourceBrand', rq);
  }

  setCancellazioneOTA(rq: PortaleXAlbergoCancellazioniOTA): Observable<WebApiResponseUpdate> {
    return this.post('Portali/UpdateCancellazioneOTA', rq);
  }

  setServizioOTA(rq: PortaleXAlbergoServiziOTA): Observable<WebApiResponseUpdate> {
    return this.post('Portali/UpdateServizioOTA', rq);
  }

  setFiltroPortale(rq: PortaleXAlbergoFiltri): Observable<WebApiResponseUpdate> {
    return this.post('Portali/UpdateFiltro', rq);
  }

  getArticoliXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('Articoli/ArticoliXLingua/Filter', WebApiRequestFilter.fromFilter('articolo.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  getTrattamento(oid: number): Observable<WebApiResponse> {
    return this.get('Trattamenti/' + oid);
  }

  checkTariffeTrattamento(oid: number): Observable<WebApiResponse> {
    return this.get('Trattamenti/' + oid + '/CheckTariffe');
  }

  getTrattamenti(oidAlbergo?: number): Observable<GetTrattamentiRS> {
    return this.get('Albergo/' + (oidAlbergo == null ? this.sessionService.getOidAlbergo() : oidAlbergo) + '/Trattamenti');
  }

  getTrattamentiFilter(rq: WebApiRequestFilter): Observable<GetTrattamentiFilterRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Trattamenti/Filter', rq);
  }

  getMenu(oidAlbergo?: number): Observable<GetMenuRS> {
    return this.get('Albergo/' + (oidAlbergo == null ? this.sessionService.getOidAlbergo() : oidAlbergo) + '/Menu');
  }

  getMenuFilter(rq: WebApiRequestFilter): Observable<GetMenuFilterRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Menu/Filter', rq);
  }

  setTrattamento(rq: SetTrattamentiXLinguaRQ): Observable<WebApiResponse> {
    return this.post('Trattamenti/Update', rq);
  }

  getArticolo(oid: number): Observable<WebApiResponse> {
    return this.get('Articoli/' + oid);
  }

  setArticolo(rq: SetArticoliXLinguaRQ): Observable<WebApiResponse> {
    return this.post('Articoli/Update', rq);
  }

  getSupplemento(oid: number): Observable<WebApiResponse> {
    return this.get('Supplementi/' + oid);
  }

  getSupplementi(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Supplementi');
  }

  getSupplementiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Supplementi/Filter', rq);
  }

  setSupplemento(rq: SetSupplementiXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('Supplementi/Update', rq);
  }

  getRiduzione(oid: number): Observable<WebApiResponse> {
    return this.get('Riduzioni/' + oid);
  }

  getRiduzioni(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Riduzioni');
  }

  getRiduzioniFilter(rq: WebApiRequestFilter, oidAlbergo?: number): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + (oidAlbergo != null ? oidAlbergo : this.sessionService.getOidAlbergo()) + '/Riduzioni/Filter', rq);
  }

  setRiduzione(rq: SetRiduzioniXLinguaRQ): Observable<WebApiResponse> {
    return this.post('Riduzioni/Update', rq);
  }

  getArrotondamento(oid: number): Observable<WebApiResponse> {
    return this.get('Arrotondamenti/' + oid);
  }

  getArrotondamenti(): Observable<GetArrotondamentiRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Arrotondamenti');
  }

  getArrotondamentiFilter(rq: WebApiRequestFilter): Observable<GetArrotondamentiFilterRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Arrotondamenti/Filter', rq);
  }

  setArrotondamento(rq: Arrotondamento): Observable<WebApiResponse> {
    return this.post('Arrotondamenti/Update', rq);
  }

  getListini(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Listini');
  }

  getListiniFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Listini/Filter', rq);
  }

  setListino(rq: Listino): Observable<WebApiResponse> {
    return this.post('Listini/Update', rq);
  }

  getAgenzie(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Agenzie');
  }

  getAgenzieFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Agenzie/Filter', rq);
  }

  setAgenzia(rq: Agenzia): Observable<WebApiResponse> {
    return this.post('Agenzie/Update', rq);
  }

  getEventi(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Eventi');
  }

  getEventiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Eventi/Filter', rq);
  }

  getEventiXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('Eventi/EventiXLingua/Filter', WebApiRequestFilter.fromFilter('evento.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setEvento(rq: SetEventiXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('Eventi/Update', rq);
  }

  getTipiCliente(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/TipiCliente');
  }

  getTipiClienteFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/TipiCliente/Filter', rq);
  }

  setTipoCliente(rq: TipoCliente): Observable<WebApiResponse> {
    return this.post('TipiCliente/Update', rq);
  }

  getUbicazioniIstatAssociateAPortale(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/UbicazioniIstatAssociateAPortale');
  }

  getCausaliOperazione(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/CausaliOperazione');
  }

  getCausaliOperazioneFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/CausaliOperazione/Filter', rq);
  }

  getCausaliOperazioneViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/CausaliOperazione/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getCausaliOperazioneXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('CausaliOperazione/CausaliOperazioneXLingua/Filter', WebApiRequestFilter.fromFilter('causaleOperazione.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setCausaleOperazione(rq: SetCausaliOperazioneXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('CausaliOperazione/Update', rq);
  }

  getPreventivo(oid: number): Observable<WebApiResponse> {
    return this.get('Preventivi/' + oid);
  }

  getUrlWhatsAppPreventivo(oid: number): Observable<WebApiResponse> {
    return this.get('Preventivi/' + oid + '/UrlWhatsApp');
  }

  getTestoSmsPreventivo(oid: number): Observable<WebApiResponse> {
    return this.get('Preventivi/' + oid + '/TestoSms');
  }

  deletePreventivo(oid: number): Observable<WebApiResponse> {
    return this.get('Preventivi/' + oid + '/Delete');
  }

  getPreventivi(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Preventivi');
  }

  getMessaggi(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Messaggi');
  }

  getMessaggiFilter(rq: GetMessaggiRQ): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Messaggi/Filter', rq);
  }

  viewPreventivo(oid: number): Observable<GetPreventivoRS> {
    return this.post('Preventivi/ViewPreventivo', new ViewPreventivoRQ(oid));
  }

  getMyPage(rq: GetMyPageRQ): Observable<GetMyPageRS> {
    return this.post('Booking/MyPage', rq);
  }

  getSondaggioPrenotazione(rq: GetSondaggioPrenotazioneRQ): Observable<GetSondaggioPrenotazioneRS> {
    return this.post('Booking/SondaggioPrenotazione', rq);
  }

  getRoomingList(rq: GetRoomingListRQ): Observable<GetRoomingListRS> {
    return this.post('Booking/RoomingList', rq);
  }

  sendMessageMyPage(rq: SendMessagePreventivoRQ): Observable<WebApiResponseUpdate> {
    return this.post('Booking/InviaMessaggioMyPage', rq);
  }

  sendMessageCheckIn(rq: SendMessageClienteRQ): Observable<WebApiResponseUpdate> {
    return this.post('Myself/InviaMessaggio', rq);
  }

  sendMessageCheckInBooking(rq: SendMessagePrenotazioneRQ): Observable<WebApiResponseUpdate> {
    return this.post('Booking/InviaMessaggioMySelf', rq);
  }

  sendMessagePaymail(rq: SendMessageTransazioneRQ): Observable<WebApiResponseUpdate> {
    return this.post('Booking/InviaMessaggioPaymail', rq);
  }

  accettaMyPage(rq: AccettaPreventivoRQ): Observable<WebApiResponse> {
    return this.post('Booking/AccettaMyPage', rq);
  }

  confermaMyPage(rq: ConfermaPreventivoRQ): Observable<WebApiResponse> {
    return this.post('Booking/ConfermaMyPage', rq);
  }

  rinnovaRichiesta(rq: RinnovaRichiestaRQ): Observable<WebApiResponse> {
    return this.post('Booking/RinnovaRichiesta', rq);
  }

  rifiutaPreventivoMyPage(rq: RifiutaPreventivoMyPageRQ): Observable<WebApiResponse> {
    return this.post('MyPage/RifiutaPreventivo', rq);
  }

  creaProposte(rq: CreaProposteRQ): Observable<WebApiResponse> {
    return this.post('Preventivi/CreaProposte', rq);
  }

  prenotaMyPage(rq: PrenotaPreventivoRQ): Observable<PrenotaPreventivoRS> {
    return this.post('Booking/PrenotaMyPage', rq);
  }

  getPrivacyPortale(rq: GetPrivacyPortaleRQ): Observable<GetPrivacyPortaleRS> {
    return this.post('Portali/Privacy', rq);
  }

  getPayMail(rq: GetPayMailRQ): Observable<GetPayMailRS> {
    return this.post('Booking/PayMail', rq);
  }

  setTransazione(rq: SetTransazioneRQ): Observable<WebApiResponse> {
    return this.post('Booking/SetTransazione', rq);
  }

  getPreventiviFilter(rq: GetPreventiviRQ): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Preventivi/Filter', rq);
  }

  getStatiPreventivi(rq: GetStatiPreventiviRQ): Observable<GetStatiPreventiviRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/StatiPreventivi', rq);
  }

  getRichieste(): Observable<GetRichiesteRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Richieste');
  }

  getRichiesteFilter(rq: GetRichiesteRQ): Observable<GetRichiesteFilterRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Richieste/Filter', rq);
  }

  getSorgentiRichiesta(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/SorgentiRichiesta');
  }

  getSorgentiRichiestaFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/SorgentiRichiesta/Filter', rq);
  }

  getPrenotazione(oid: number): Observable<WebApiResponse> {
    return this.get('Prenotazioni/' + oid);
  }

  getPrenotazioni(): Observable<GetPrenotazioniRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Prenotazioni');
  }

  getPrenotazioniFilter(rq: WebApiRequestFilter): Observable<GetPrenotazioniFilterRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Prenotazioni/Filter', rq);
  }

  setAlbergo(rq: Albergo): Observable<WebApiResponseUpdate> {
    return this.post('Albergo/Update', rq);
  }

  setAlbergoMaster(rq: SetAlberghiMasterXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('AlbergoMaster/Update', rq);
  }

  setPrenotazione(rq: Prenotazione): Observable<WebApiResponse> {
    return this.post('Prenotazioni/Update', rq);
  }

  salvaCartaCreditoPrenotazione(oidPrenotazione: number, rq: PaymentModel): Observable<WebApiResponse> {
    return this.post('Prenotazioni/' + oidPrenotazione + '/SalvaCartaCredito', rq);
  }

  getPrenotazioneDetails(rq: GetDetailPrenotazioneRQ): Observable<DetailPrenotazioneRS> {
    return this.post('Prenotazioni/DetailPrenotazione', rq);
  }

  getStoricoPrenotazione(rq: GetStoricoPrenotazioneRQ): Observable<WebApiResponse> {
    return this.post('Prenotazioni/Storico', rq);
  }

  deletePrenotazione(oid: number): Observable<WebApiResponse> {
    return this.get('Prenotazioni/' + oid + '/Delete');
  }

  getCodicePromozioneDetails(oid: number): Observable<DetailCodicePromozioneRS> {
    return this.get('CodiciPromozione/' + oid + '/Detail');
  }

  getDashboard(rq: DashboardRQ): Observable<DashboardHotelRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ViewDashboard', rq);
  }

  getDashboards(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Dashboards');
  }

  setDashboard(rq: Dashboard): Observable<WebApiResponse> {
    return this.post('Dashboard/Update', rq);
  }

  getPlanning(rq: PlanningRQ): Observable<PlanningRS> {
    return this.post('Disponibilita/ViewPlanning', rq);
  }

  getPlanningMaster(rq: PlanningMasterRQ): Observable<PlanningMasterRS> {
    return this.post('Disponibilita/PlanningMaster', rq);
  }

  pubblicaDisponibilita(rq: PubblicaDisponibilitaRQ): Observable<PubblicaDisponibilitaRS> {
    return this.post('Disponibilita/Pubblica', rq);
  }

  pubblicaDisponibilitaGiorno(rq: PubblicaDisponibilitaGiornoRQ): Observable<PubblicaDisponibilitaRS> {
    return this.post('Disponibilita/PubblicaDisponibilitaGiorno', rq);
  }

  getGiorniDaPubblicare(rq: GetGiorniDaPubblicareRQ): Observable<WebApiResponse> {
    return this.post('Disponibilita/GetGiorniDaPubblicare', rq);
  }

  bloccaPubblicazioneAutomatica(rq: BloccaPubblicazioneAutomaticaRQ): Observable<WebApiResponse> {
    return this.post('Disponibilita/BloccaPubblicazioneAutomatica', rq);
  }

  sbloccaPubblicazioneAutomatica(rq: SbloccaPubblicazioneAutomaticaRQ): Observable<WebApiResponse> {
    return this.post('Disponibilita/SbloccaPubblicazioneAutomatica', rq);
  }

  pubblicaDerivedPrices(rq: PubblicaDerivedPricesRQ): Observable<PubblicaDerivedPricesRS> {
    return this.post('Portali/PubblicaDerivedPrices', rq);
  }

  updateAllDisponibilita(rq: UpdateAllDisponibilitaRQ): Observable<WebApiResponse> {
    return this.post('Disponibilita/UpdateAll', rq);
  }

  updateFromDisponibiliHotel(rq: UpdateFromDisponibiliHotelRQ): Observable<WebApiResponse> {
    return this.post('Disponibilita/UpdateFromDisponibiliHotel', rq);
  }

  updatePrezzi(rq: UpdatePrezziRQ): Observable<WebApiResponse> {
    return this.post('Disponibilita/UpdatePrezzi', rq);
  }

  updateDisponibilita(rq: UpdateDisponibilitaRQ): Observable<WebApiResponse> {
    return this.post('Disponibilita/Update', rq);
  }

  updateMultipleDisponibilita(rq: DisponibilitaXPortaleXAlbergo[]): Observable<WebApiResponse> {
    return this.post('Disponibilita/UpdateMultiple', rq);
  }

  getCancellazione(oid: number): Observable<WebApiResponse> {
    return this.get('Cancellazioni/' + oid);
  }

  getCancellazioni(): Observable<GetCancellazioniRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Cancellazioni');
  }

  getCancellazioniFilter(rq: WebApiRequestFilter): Observable<GetCancellazioniFilterRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Cancellazioni/Filter', rq);
  }

  getCancellazioniXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('Cancellazioni/CancellazioniXLingua/Filter', WebApiRequestFilter.fromFilter('cancellazione.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setCancellazione(rq: SetCancellazioniXLinguaRQ): Observable<WebApiResponse> {
    return this.post('Cancellazioni/Update', rq);
  }

  getModalitaPagamentoDefault(rq: GetModalitaPagamentoDefaultRQ): Observable<WebApiResponse> {
    return this.post('Albergo/ModalitaPagamentoDefault', rq);
  }

  getModalitaPagamento(oid: number): Observable<WebApiResponse> {
    return this.get('ModalitaPagamento/' + oid);
  }

  getModalitaPagamentoList(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ModalitaPagamento');
  }

  getModalitaPagamentoFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ModalitaPagamento/Filter', rq);
  }

  getModalitaPagamentoXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('ModalitaPagamento/ModalitaPagamentoXLingua/Filter', WebApiRequestFilter.fromFilter('modalitaPagamento.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  getPaymentMethods(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/PaymentMethods');
  }

  getPaymentMethodsFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/PaymentMethods/Filter', rq);
  }

  getTipiCarteCredito(oidAlbergo?: number): Observable<WebApiResponse> {
    return this.get('Albergo/' + (oidAlbergo == null ? this.sessionService.getOidAlbergo() : oidAlbergo) + '/TipiCarteCredito');
  }

  getTipiCarteCreditoFilter(rq: WebApiRequestFilter, oidAlbergo?: number): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + (oidAlbergo != null ? oidAlbergo : this.sessionService.getOidAlbergo()) + '/TipiCarteCredito/Filter', rq);
  }

  getTipoCartaCredito(oid: number): Observable<WebApiResponse> {
    return this.get('TipiCarteCredito/' + oid);
  }

  setTipoCartaCredito(rq: TipoCartaCreditoXAlbergo): Observable<WebApiResponse> {
    return this.post('TipiCarteCredito/Update', rq);
  }

  setAllTipiCarteCredito(tipiCarteCredito: TipoCartaCreditoXAlbergo[]): Observable<WebApiResponse> {
    return this.post('TipiCarteCredito/UpdateAll', new SetTipiCarteCreditoRQ(this.sessionService.getOidAlbergo(), tipiCarteCredito));
  }

  setModalitaPagamento(rq: SetModalitaPagamentoXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('ModalitaPagamento/Update', rq);
  }

  getMySelfConfig(rq: GetMySelfConfigRQ): Observable<GetMySelfConfigRS> {
    return this.post('MySelf/GetMySelfConfig', rq);
  }

  getMySelf(rq: GetMySelfRQ): Observable<GetMySelfRS> {
    return this.post('MySelf', rq);
  }

  getOffer(rq: GetOfferRQ): Observable<GetOfferRS> {
    return this.post('Booking/Offer', rq);
  }

  getMySelfBooking(rq: GetMySelfBookingRQ): Observable<GetMySelfBookingRS> {
    return this.post('Booking/MySelf', rq);
  }

  getChiusureGiornaliere(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ChiusureGiornaliereHotel');
  }

  getChiusureGiornaliereFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ChiusureGiornaliereHotel/Filter', rq);
  }

  setDatiCheckIn(rq: setDatiCheckInRQ): Observable<WebApiResponse> {
    return this.post('Prenotazioni/DatiCheckIn/Update', rq);
  }

  setDatiCheckInMultiple(rq: setDatiCheckInMultipleRQ): Observable<WebApiResponse> {
    return this.post('Prenotazioni/DatiCheckIn/UpdateMultiple', rq);
  }

  getComuni(): Observable<WebApiResponse> {
    return this.get('Comuni');
  }

  getComuniFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Comuni/Filter', rq);
  }

  setComune(rq: Comune): Observable<WebApiResponse> {
    return this.post('Comuni/Update', rq);
  }

  getTipoCameraOTA(oid: number): Observable<WebApiResponse> {
    return this.get('TipiCamereOTA/' + oid);
  }

  checkDisponibilitaFutureNonPubblicate(oidPortale: number): Observable<WebApiResponse> {
    return this.get('Portali/' + oidPortale + '/CheckDisponibilitaFutureNonPubblicate');
  }

  checkDisponibilitaFuturePubblicate(rq: CheckDisponibilitaFuturePubblicateRQ): Observable<WebApiResponse> {
    return this.post('Portali/CheckDisponibilitaFuturePubblicate', rq);
  }

  controllaConfigurazionePortaleMaster(oidPortale: number): Observable<WebApiResponse> {
    return this.get('Portali/' + oidPortale + '/ControllaConfigurazione');
  }

  getConfigurazionePortaleMaster(oidPortale: number): Observable<GetConfigurazioneMasterRS> {
    return this.get('Portali/' + oidPortale + '/GetConfigurazioneMaster');
  }

  getTipiCameraOTA(oidPortale: number): Observable<WebApiResponse> {
    return this.get('Portali/' + oidPortale + '/TipiCamere');
  }

  getTariffeOTA(oidPortale: number): Observable<WebApiResponse> {
    return this.get('Portali/' + oidPortale + '/Tariffe');
  }

  getTariffeCollegate(oidTipoCamera: number, oidTariffa: number): Observable<GetTariffeCollegateRS> {
    return this.post('TariffeOTA/' + oidTariffa + '/TariffeCollegate', new GetTariffeCollegateRQ(oidTipoCamera));
  }

  getTipiCameraOTAXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('TipiCamereOTA/TipiCameraOTAXLingua/Filter', WebApiRequestFilter.fromFilter('tipoCameraOTA.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  getTipiCameraOTAXLinguaXImmagini(oid: number): Observable<GetTipoCameraOTARS> {
    return this.post('TipiCamereOTA/TipiCameraOTAXLinguaXImmagini/Filter', WebApiRequestFilter.fromFilter('tipoCameraOTA.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  getCalendariTipoCameraOTA(oidTipocamera: number): Observable<WebApiResponse> {
    return this.get('TipiCamereOTA/' + oidTipocamera + '/Calendari');
  }

  getComponentiTipoCameraOTA(oidTipocamera: number): Observable<WebApiResponse> {
    return this.get('TipiCamereOTA/' + oidTipocamera + '/Componenti');
  }

  getUpgradeGratuitiTipoCameraOTA(oidTipocamera: number): Observable<WebApiResponse> {
    return this.get('TipiCamereOTA/' + oidTipocamera + '/UpgradeGratuiti');
  }

  setTipoCameraOTA(rq: SetTipiCameraOTAXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('TipiCamereOTA/Update', rq);
  }

  setCalendarioTipoCameraOTA(rq: TipoCameraOTACalendar): Observable<WebApiResponse> {
    return this.post('TipiCamereOTA/UpdateCalendario', rq);
  }

  setComponenteTipoCameraOTA(rq: TipoCameraOTAXComponente): Observable<WebApiResponse> {
    return this.post('TipiCamereOTA/UpdateComponente', rq);
  }

  setComponentiTipoCameraOTA(rq: TipoCameraOTAXComponente[]): Observable<WebApiResponse> {
    return this.post('TipiCamereOTA/UpdateComponenti', rq);
  }

  setUpgradeGratuitoTipoCameraOTA(rq: TipoCameraOTAUpgrade): Observable<WebApiResponse> {
    return this.post('TipiCamereOTA/UpdateUpgradeGratuito', rq);
  }

  getTariffaOTA(oid: number): Observable<WebApiResponse> {
    return this.get('TariffeOTA/' + oid);
  }

  getTariffeOTAXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('TariffeOTA/TariffeOTAXLingua/Filter', WebApiRequestFilter.fromFilter('tariffaOTA.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setTariffaOTA(rq: SetTariffeOTAXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('TariffeOTA/Update', rq);
  }

  updateTariffaOTA(rq: TariffaOTA): Observable<WebApiResponseUpdate> {
    return this.post('TariffeOTA/UpdateTariffa', rq);
  }

  verificaCodiceMaster(oid: number, codiceMaster: string): Observable<WebApiResponse> {
    return this.post('TariffeOTA/' + oid + '/VerificaCodiceMaster', new VerificaCodiceMasterRQ(codiceMaster));
  }

  getTariffeDerivateTariffaOTA(oidTariffa: number): Observable<WebApiResponse> {
    return this.get('TariffeOTA/' + oidTariffa + '/TariffeDerivate');
  }

  setTariffaDerivataTariffaOTA(rq: TariffaOTADerivata): Observable<WebApiResponse> {
    return this.post('TariffeOTA/UpdateTariffaDerivata', rq);
  }

  getNazioniViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Nazioni/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getRegioniViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Regioni/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getTipiCameraOTAViewSelect(oid: number, rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Portali/' + oid + '/TipiCameraOTA/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getTariffeOTAViewSelect(oid: number, rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Portali/' + oid + '/TariffeOTA/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getArticoliViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Articoli/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getVociAddebitoViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/VociAddebito/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getParametriRicercaViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ParametriRicerca/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getUtentiViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Utenti/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getCodiciPromozioneViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/CodiciPromozione/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getLingueViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Lingue/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getPortaliViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Portali/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getTagCrmViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true, oidAlbergo?: number): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + (oidAlbergo != null ? oidAlbergo : this.sessionService.getOidAlbergo()) + '/TagCrm/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getAgenzieViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Agenzie/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getAccountMailViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/AccountMail/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getTrattamentiViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Trattamenti/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getPromozioniViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Promozioni/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getPortaliXAlbergoViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/PortaliXAlbergo/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getUbicazioniIstatViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true, oidAlbergo?: number): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + (oidAlbergo > 0 ? oidAlbergo : this.sessionService.getOidAlbergo()) + '/UbicazioniIstat/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getValuteViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Valute/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getCancellazioniViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Cancellazioni/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getListiniViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Listini/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getCreditiViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Crediti/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getArrotondamentiViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Arrotondamenti/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getTipiCameraViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/TipiCamera/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getTipiCameraStandardViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/TipiCameraStandard/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getComponentiXVariazioneViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ComponentiXVariazione/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getFasceViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Fasce/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getTipiClienteViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/TipiCliente/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getTipiPagamentoViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/TipiPagamento/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getPreparazioniCameraViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/PreparazioniCamera/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getPianiTariffariViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/PianiTariffari/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  salvaFascia(rq: ViewFascia): Observable<WebApiResponse> {
    return this.post('CalendarioFasce/SalvaFascia', rq);
  }

  getFascia(rq: GetFasciaRQ): Observable<WebApiResponse> {
    return this.post('Disponibilita/GetFascia', rq);
  }

  getCalendarioFasceForm(rq: CalendarioFasceFormRQ): Observable<CalendarioFasceFormRS> {
    return this.post('CalendarioFasce/GetCalendarioFasceForm', rq);
  }

  salvaFasce(rq: SalvaFasceRQ): Observable<SalvaFasceRS> {
    return this.post('CalendarioFasce/SalvaFasce', rq);
  }

  aggiornaFasceWelcome(rq: AggiornaFasceWelcomeRQ): Observable<WebApiResponse> {
    return this.post('CalendarioFasce/AggiornaFasceWelcome', rq);
  }

  getRichiesta(oid: number): Observable<WebApiResponse> {
    return this.get('Richieste/' + oid);
  }

  setRichiesta(rq: Richiesta): Observable<WebApiResponse> {
    return this.post('Richieste/Update', rq);
  }

  setRichiestaCamere(rq: Richiesta): Observable<WebApiResponse> {
    return this.post('Richieste/UpdateCamere', rq);
  }

  getRichiestaDetails(oid: number): Observable<DetailRichiestaRS> {
    return this.get('Richieste/' + oid + '/Detail');
  }

  setSorgentiRichiesta(rq: SorgenteRichiesta[]): Observable<WebApiResponse> {
    return this.post('Richieste/UpdateSorgentiRichiesta', rq);
  }

  creaPreventivo(rq: CreaPreventivoRQ): Observable<CreaPreventivoRS> {
    return this.post('Richieste/CreaPreventivo', rq);
  }

  creaRichiestaPreventivo(rq: CreaRichiestaPreventivoRQ): Observable<CreaRichiestaPreventivoRS> {
    return this.post('Richieste/CreaRichiestaPreventivo', rq);
  }

  generaOpzioni(rq: GeneraOpzioniRQ): Observable<GeneraOpzioniRS> {
    return this.post('Richieste/GeneraOpzioni', rq);
  }

  setPreventivo(rq: Preventivo): Observable<WebApiResponseUpdate> {
    return this.post('Preventivi/Update', rq);
  }

  sendMessageCliente(rq: SendMessageClienteRQ): Observable<WebApiResponseUpdate> {
    return this.post('Clienti/InviaMessaggio', rq);
  }

  sendMessageTransazione(rq: SendMessageTransazioneRQ): Observable<WebApiResponseUpdate> {
    return this.post('Transazioni/InviaMessaggio', rq);
  }

  sendMessagePrenotazione(rq: SendMessagePrenotazioneRQ): Observable<WebApiResponseUpdate> {
    return this.post('Prenotazioni/InviaMessaggio', rq);
  }

  impostaMessaggiLettiPrenotazione(oid: number): Observable<WebApiResponse> {
    return this.get('Prenotazioni/' + oid + '/ImpostaMessaggiLetti');
  }

  impostaMessaggiLettiHotelPrenotazione(oid: number): Observable<WebApiResponse> {
    return this.get('Prenotazioni/' + oid + '/ImpostaMessaggiLettiHotel');
  }

  impostaPrenotazioneImportata(oid: number): Observable<WebApiResponse> {
    return this.get('Prenotazioni/' + oid + '/ImpostaImportata');
  }

  impostaPrenotazioneDaImportare(oid: number): Observable<WebApiResponse> {
    return this.get('Prenotazioni/' + oid + '/ImpostaDaImportare');
  }

  impostaModalitaPagamentoPrenotazione(rq: ImpostaModalitaPagamentoPrenotazioneRQ): Observable<WebApiResponse> {
    return this.post('Prenotazioni/ImpostaModalitaPagamento', rq);
  }

  impostaMessaggiLettiCliente(oid: number): Observable<WebApiResponse> {
    return this.get('Clienti/' + oid + '/ImpostaMessaggiLetti');
  }

  impostaMessaggiLettiHotelCliente(oid: number): Observable<WebApiResponse> {
    return this.get('Clienti/' + oid + '/ImpostaMessaggiLettiHotel');
  }

  sendMessage(rq: SendMessagePreventivoRQ): Observable<WebApiResponseUpdate> {
    return this.post('Preventivi/InviaMessaggio', rq);
  }

  impostaMessaggiLettiPreventivo(oid: number): Observable<WebApiResponse> {
    return this.get('Preventivi/' + oid + '/ImpostaMessaggiLetti');
  }

  eliminaMessaggio(oid: number): Observable<WebApiResponse> {
    return this.post('Albergo/EliminaMessaggio', new EliminaMessaggioRQ(oid));
  }

  impostaLettoMessaggio(oid: number): Observable<WebApiResponse> {
    return this.post('Albergo/ImpostaLettoMessaggio', new ImpostaLettoMessaggioRQ(oid));
  }

  impostaLettiMessaggi(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ImpostaLettiMessaggi');
  }

  impostaDaLeggereMessaggio(oid: number): Observable<WebApiResponse> {
    return this.post('Albergo/ImpostaDaLeggereMessaggio', new ImpostaDaLeggereMessaggioRQ(oid));
  }

  sendPreventivo(rq: InviaPreventivoRQ): Observable<InviaPreventivoRS> {
    return this.post('Preventivi/Invia', rq);
  }

  rifiutaPreventivo(rq: RifiutaPreventivoRQ): Observable<RifiutaPreventivoRS> {
    return this.post('Preventivi/Rifiuta', rq);
  }

  cancellaPreventivo(rq: CancellaPreventivoRQ): Observable<CancellaPreventivoRS> {
    return this.post('Preventivi/Cancella', rq);
  }

  rifiutaRichiesta(rq: RifiutaRichiestaRQ): Observable<RifiutaRichiestaRS> {
    return this.post('Richieste/Rifiuta', rq);
  }

  sendEmailCliente(rq: InviaEmailClienteRQ): Observable<InviaEmailClienteRS> {
    return this.post('Clienti/InviaEmail', rq);
  }

  sendEmailPrenotazione(rq: InviaEmailPrenotazioneRQ): Observable<InviaEmailPrenotazioneRS> {
    return this.post('Prenotazioni/InviaEmail', rq);
  }

  emettiVoucher(rq: EmettiVoucherRQ): Observable<WebApiResponse> {
    return this.post('Prenotazioni/EmettiVoucher', rq);
  }

  sendEmailTransazione(rq: InviaEmailTransazioneRQ): Observable<InviaEmailTransazioneRS> {
    return this.post('Transazioni/InviaEmail', rq);
  }

  sendEmailVoucher(rq: InviaEmailVoucherRQ): Observable<InviaEmailVoucherRS> {
    return this.post('Prenotazioni/InviaEmailVoucher', rq);
  }

  prenotaPreventivo(rq: PrenotaPreventivoRQ): Observable<PrenotaPreventivoRS> {
    return this.post('Preventivi/Prenota', rq);
  }

  checkPreventivo(oid: number): Observable<WebApiResponse> {
    return this.get('Preventivi/' + oid + '/Check');
  }

  updateTotals(rq: UpdateTotalsPreventivoRQ): Observable<WebApiResponse> {
    return this.post('Preventivi/UpdateTotals', rq);
  }

  setProposta(rq: PreventivoCamereProposte): Observable<WebApiResponseUpdate> {
    return this.post('Preventivi/UpdateProposta', rq);
  }

  setMultipleProposta(rq: PreventivoCamereProposte[]): Observable<WebApiResponse> {
    return this.post('Preventivi/UpdateMultipleProposta', rq);
  }

  setDettaglio(rq: PreventivoCamereProposteDettagli): Observable<WebApiResponseUpdate> {
    return this.post('Preventivi/UpdateDettaglio', rq);
  }

  setMultipleDettaglio(rq: PreventivoCamereProposteDettagli[]): Observable<WebApiResponseUpdate> {
    return this.post('Preventivi/UpdateMultipleDettaglio', rq);
  }

  creaRichiesta(rq: CreaRichiestaRQ): Observable<CreaRichiestaRS> {
    return this.post('Booking/CreaRichiesta', rq);
  }

  getUbicazioneIstat(oid: number): Observable<WebApiResponse> {
    return this.get('UbicazioniIstat/' + oid);
  }

  getUbicazioniIstat(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/UbicazioniIstat');
  }

  getUbicazioniIstatFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/UbicazioniIstat/Filter', rq);
  }

  getUbicazioniIstatXLingua(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/UbicazioniIstatXLingua');
  }

  getUbicazioniIstatXLinguaFilter(rq: WebApiRequestFilter, oidAlbergo?: number): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + (oidAlbergo > 0 ? oidAlbergo : this.sessionService.getOidAlbergo()) + '/UbicazioniIstatXLingua/Filter', rq);
  }

  setUbicazioneIstat(rq: SetUbicazioniIstatXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('UbicazioniIstat/Update', rq);
  }

  setUbicazioniIstat(rq: SetUbicazioniIstatXLinguaRQ[]): Observable<WebApiResponseUpdateDetails[]> {
    return this.post('UbicazioniIstat/UpdateMultiple', rq);
  }

  updateUbicazioneIstat(rq: UbicazioneIstat): Observable<WebApiResponseUpdate> {
    return this.post('UbicazioniIstat/UpdateUbicazioneIstat', rq);
  }

  setUbicazioniIstatXLingua(rq: UbicazioneIstatXLingua[]): Observable<WebApiResponse> {
    return this.post('UbicazioniIstat/UpdateUbicazioniIstatXLingua', rq);
  }

  setImmagineUbicazioneIstat(rq: SetImmagineUbicazioneIstatRQ): Observable<SetImmagineUbicazioneIstatRS> {
    return this.post('UbicazioniIstat/UpdateImmagine', rq);
  }

  getClienti(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Clienti');
  }

  getClientiFilter(rq: GetClientiRQ): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Clienti/Filter', rq);
  }

  deleteCliente(oid: number): Observable<WebApiResponse> {
    return this.get('Clienti/' + oid + '/Delete');
  }

  setCliente(rq: Cliente): Observable<WebApiResponseUpdate> {
    return this.post('Clienti/Update', rq);
  }

  getClienteDetails(oid: number): Observable<DetailClienteRS> {
    return this.get('Clienti/' + oid + '/Detail');
  }

  newsletterUnsubscribe(oid: number): Observable<WebApiResponse> {
    return this.get('Clienti/' + oid + '/NewsletterUnsubscribe');
  }

  getUtenti(): Observable<GetUtentiRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Utenti');
  }

  getUtentiFilter(rq: WebApiRequestFilter): Observable<GetUtentiFilterRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Utenti/Filter', rq);
  }

  setUtente(rq: Utente): Observable<WebApiResponse> {
    return this.post('Utenti/Update', rq);
  }

  setPermessiUtente(rq: UpdatePermessiRQ): Observable<WebApiResponse> {
    return this.post('Utenti/UpdatePermessi', rq);
  }

  deleteAllProposte(rq: DeleteAllProposteRQ): Observable<WebApiResponse> {
    return this.post('Preventivi/DeleteAllProposte', rq);
  }

  duplicaProposta(oidProposta: number): Observable<DuplicaPropostaRS> {
    return this.get('Preventivi/DuplicaProposta/' + oidProposta);
  }

  duplicaDettaglio(oidDettaglio: number): Observable<WebApiResponse> {
    return this.get('Preventivi/DuplicaDettaglio/' + oidDettaglio);
  }

  getCodicePromozione(oid: number): Observable<WebApiResponse> {
    return this.get('CodiciPromozione/' + oid);
  }

  getCodiciPromozione(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/CodiciPromozione');
  }

  getCodiciPromozioneFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/CodiciPromozione/Filter', rq);
  }

  getCodiciPromozioneXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('CodiciPromozione/CodiciPromozioneXLingua/Filter', WebApiRequestFilter.fromFilter('codicePromozione.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setCodicePromozione(rq: SetCodiciPromozioneXLinguaRQ): Observable<WebApiResponse> {
    return this.post('CodiciPromozione/Update', rq);
  }

  getCodiciPromozioneValidiRichiesta(oidRichiesta: number): Observable<WebApiResponse> {
    return this.get('Richieste/' + oidRichiesta + '/CodiciPromozioneValidi');
  }

  getCodiciPromozioneValidi(rq: GetCodiciPromozioneValidiRQ): Observable<WebApiResponse> {
    return this.post('Albergo/CodiciPromozioneValidi', rq);
  }

  getBanner(oid: number): Observable<WebApiResponse> {
    return this.get('Banner/' + oid);
  }

  getBanners(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Banner');
  }

  getBannersFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Banner/Filter', rq);
  }

  getBannerXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('Banner/BannerXLingua/Filter', WebApiRequestFilter.fromFilter('banner.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setBanner(rq: SetBannerXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('Banner/Update', rq);
  }

  getMotivoViaggio(oid: number): Observable<WebApiResponse> {
    return this.get('MotiviViaggio/' + oid);
  }

  getMotiviViaggio(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/MotiviViaggio');
  }

  getMotiviViaggioFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/MotiviViaggio/Filter', rq);
  }

  getMotiviViaggioXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('MotiviViaggio/MotiviViaggioXLingua/Filter', WebApiRequestFilter.fromFilter('motivazioneViaggio.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setMotivoViaggio(rq: SetMotiviViaggioXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('MotiviViaggio/Update', rq);
  }

  getRecensione(oid: number): Observable<WebApiResponse> {
    return this.get('Recensioni/' + oid);
  }

  getRecensioni(oidPortale: number): Observable<WebApiResponse> {
    return this.get('Portali/' + oidPortale + '/Recensioni');
  }

  getRecensioniXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('Recensioni/RecensioniXLingua/Filter', WebApiRequestFilter.fromFilter('recensione.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setRecensione(rq: SetRecensioniXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('Recensioni/Update', rq);
  }

  getBloccoHtml(oid: number): Observable<WebApiResponse> {
    return this.get('BlocchiHtml/' + oid);
  }

  getBlocchiHtml(oidPortale: number): Observable<WebApiResponse> {
    return this.get('Portali/' + oidPortale + '/BlocchiHtml');
  }

  getBlocchiHtmlXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('BlocchiHtml/BlocchiHtmlXLingua/Filter', WebApiRequestFilter.fromFilter('bloccoHtml.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setBloccoHtml(rq: SetBlocchiHtmlXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('BlocchiHtml/Update', rq);
  }

  getAlbergoMaster(oid: number): Observable<WebApiResponse> {
    return this.get('AlbergoMaster/' + oid);
  }

  checkAlbergoMaster(oid: number): Observable<CheckAlbergoMasterRS> {
    return this.get('AlbergoMaster/' + oid + '/Check');
  }

  getAlbergoMasterDetails(oid: number): Observable<DetailAlbergoMasterRS> {
    return this.get('AlbergoMaster/' + oid + '/Detail');
  }

  getServizioDmsDetails(oid: number): Observable<DetailServizioDmsRS> {
    return this.get('ServiziDms/' + oid + '/Detail');
  }

  getAllAlberghi(): Observable<WebApiResponse> {
    return this.get('Albergo');
  }

  getAlberghi(): Observable<WebApiResponse> {
    return this.get('Admin/Alberghi');
  }

  getAlberghiFilter(rq: GetAlberghiRQ): Observable<WebApiResponseFilter> {
    return this.post('Admin/Alberghi/Filter', rq);
  }

  getAlberghiViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Admin/Alberghi/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getAlberghiListXAlbergoMaster(oid: number): Observable<WebApiResponse> {
    return this.post('Albergo/Filter', WebApiRequestFilter.fromFilters([new Filter('albergoMaster.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number), new Filter('oid', CriteriaOperator.NotEqual, this.sessionService.getOidAlbergo().toString(), FilterValueType.Number)]));
  }

  getAlberghiMaster(): Observable<WebApiResponse> {
    return this.get('Admin/AlberghiMaster');
  }

  getAlberghiMasterFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Admin/AlberghiMaster/Filter', rq);
  }

  getPrenotazioniExtraAlbergo(): Observable<GetPrenotazioniExtraRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/PrenotazioniExtra');
  }

  getPrenotazioniExtraAlbergoFilter(rq: WebApiRequestFilter): Observable<GetPrenotazioniExtraFilterRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/PrenotazioniExtra/Filter', rq);
  }

  getPickup(rq: RequestPickupRQ): Observable<RequestPickupRS> {
    return this.post('Albergo/Pickup', rq);
  }

  getPickupPreventivi(rq: RequestPickupPreventiviRQ): Observable<RequestPickupPreventiviRS> {
    return this.post('Albergo/PickupPreventivi', rq);
  }

  getClientiProfilati(rq: GetClientiProfilatiRQ): Observable<GetClientiProfilatiRS> {
    return this.post('Albergo/ClientiProfilati', rq);
  }

  getStoricoAlbergo(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Storico');
  }

  getStoricoAlbergoFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Storico/Filter', rq);
  }

  setPrenotazioneExtra(rq: PrenotazioneExtra): Observable<WebApiResponse> {
    return this.post('PrenotazioniExtra/Update', rq);
  }

  getParametriRicerca(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ParametriRicerca');
  }

  getParametriRicercaFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ParametriRicerca/Filter', rq);
  }

  getParametriRicercaXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('ParametriRicerca/ParametriRicercaXLingua/Filter', WebApiRequestFilter.fromFilter('parametroRicerca.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setParametroRicerca(rq: SetParametriRicercaXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('ParametriRicerca/Update', rq);
  }

  getInteressi(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Interessi');
  }

  getInteressiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Interessi/Filter', rq);
  }

  setInteresse(rq: Interesse): Observable<WebApiResponse> {
    return this.post('Interessi/Update', rq);
  }

  getPianiTariffari(): Observable<GetPianiTariffariRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/PianiTariffari');
  }

  getPianiTariffariFilter(rq: WebApiRequestFilter): Observable<GetPianiTariffariFilterRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/PianiTariffari/Filter', rq);
  }

  setPianoTariffario(rq: UpdatePianoTariffarioRQ): Observable<WebApiResponse> {
    return this.post('PianiTariffari/Update', rq);
  }

  getBookingRules(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/BookingRules');
  }

  getBookingRulesFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/BookingRules/Filter', rq);
  }

  setBookingRule(rq: BookingRules): Observable<WebApiResponse> {
    return this.post('BookingRules/Update', rq);
  }

  getReportList(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Report');
  }

  getReportListFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Report/Filter', rq);
  }

  setReport(rq: ReportHotel): Observable<WebApiResponse> {
    return this.post('ReportHotel/Update', rq);
  }

  setImmagineTipoCameraOTA(rq: ImmagineXTipoCameraOTA): Observable<WebApiResponseUpdate> {
    return this.post('TipiCamereOTA/UpdateImmagine', rq);
  }

  setImmaginePortale(rq: SetImmaginePortaleRQ): Observable<SetImmaginePortaleRS> {
    return this.post('Portali/UpdateImmagine', rq);
  }

  setImmaginePromozione(rq: SetImmaginePromozioneRQ): Observable<SetImmaginePromozioneRS> {
    return this.post('Promozioni/UpdateImmagine', rq);
  }

  setImmaginePortaleList(rq: PortaleXAlbergoImmagini): Observable<WebApiResponseUpdate> {
    return this.post('Portali/UpdateImmaginePortale', rq);
  }

  deleteAllImagesTipoCamera(oid: number): Observable<WebApiResponse> {
    return this.get('TipiCamereOTA/' + oid + '/DeleteAllImages');
  }

  setImmagineTagCrm(rq: SetImmagineTagCrmRQ): Observable<SetImmagineTagCrmRS> {
    return this.post('TagCrm/UpdateImmagine', rq);
  }

  setImmagineTagCrmList(rq: TagCrmImmagini): Observable<WebApiResponseUpdate> {
    return this.post('TagCrm/UpdateImmagineTagCrm', rq);
  }

  setImmagineVoceAddebito(rq: SetImmagineVoceAddebitoRQ): Observable<SetImmagineVoceAddebitoRS> {
    return this.post('VociAddebito/UpdateImmagine', rq);
  }

  setImmagineSupplemento(rq: SetImmagineSupplementoRQ): Observable<SetImmagineSupplementoRS> {
    return this.post('Supplementi/UpdateImmagine', rq);
  }

  setImmagineArticolo(rq: SetImmagineArticoloRQ): Observable<SetImmagineArticoloRS> {
    return this.post('Articoli/UpdateImmagine', rq);
  }

  setImmagineTemplate(rq: SetImmagineTemplateRQ): Observable<SetImmagineTemplateRS> {
    return this.post('Templates/UpdateImmagine', rq);
  }

  setImmagineTipoCamera(rq: SetImmagineTipoCameraRQ): Observable<SetImmagineTipoCameraRS> {
    return this.post('TipiCamere/UpdateImmagine', rq);
  }

  setImmagineRisorsa(rq: RisorsaImmagini): Observable<WebApiResponseUpdate> {
    return this.post('Risorse/UpdateImmagine', rq);
  }

  setImmagineEvento(rq: SetImmagineEventoRQ): Observable<SetImmagineEventoRS> {
    return this.post('Eventi/UpdateImmagine', rq);
  }

  setImmagineUtente(rq: SetImmagineUtenteRQ): Observable<SetImmagineUtenteRS> {
    return this.post('Utenti/UpdateImmagine', rq);
  }

  setImmagineServizio(rq: SetImmagineServizioRQ): Observable<SetImmagineServizioRS> {
    return this.post('Servizi/UpdateImmagine', rq);
  }

  setImmagineSistemazione(rq: SetImmagineSistemazioneRQ): Observable<SetImmagineSistemazioneRS> {
    return this.post('Sistemazioni/UpdateImmagine', rq);
  }

  setImmagineAlbergoMaster(rq: SetImmagineAlbergoMasterRQ): Observable<SetImmagineAlbergoMasterRS> {
    return this.post('AlbergoMaster/UpdateImmagine', rq);
  }

  setImmagineAlbergoMasterList(rq: AlbergoMasterImmagini): Observable<WebApiResponseUpdate> {
    return this.post('AlbergoMaster/UpdateImmagineAlbergoMaster', rq);
  }

  setImmagineTutorial(rq: SetImmagineTutorialRQ): Observable<SetImmagineTutorialRS> {
    return this.post('VideoTutorial/UpdateImmagine', rq);
  }

  setImmaginePaginaMySelf(rq: SetImmaginePaginaMySelfRQ): Observable<SetImmaginePaginaMySelfRS> {
    return this.post('MySelfConfigurazione/UpdateImmaginePagina', rq);
  }

  setImmaginePiattoMySelf(rq: SetImmaginePiattoMySelfRQ): Observable<SetImmaginePiattoMySelfRS> {
    return this.post('MySelfConfigurazione/UpdateImmaginePiatto', rq);
  }

  getPortaliAdmin(): Observable<WebApiResponse> {
    return this.get('Admin/Portali');
  }

  getPortaliAdminFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Admin/Portali/Filter', rq);
  }

  getPortaliXAlbergoAdmin(): Observable<WebApiResponse> {
    return this.get('Admin/PortaliXAlbergo');
  }

  getPortaliXAlbergoAdminFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Admin/PortaliXAlbergo/Filter', rq);
  }

  setPortaleAdmin(rq: Portale): Observable<WebApiResponseUpdate> {
    return this.post('Admin/UpdatePortale', rq);
  }

  getMessaggiAdmin(): Observable<WebApiResponse> {
    return this.get('Admin/Messaggi');
  }

  getMessaggiAdminFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Admin/Messaggi/Filter', rq);
  }

  setMessaggioAdmin(rq: MessaggioExtranet): Observable<WebApiResponseUpdate> {
    return this.post('Admin/UpdateMessaggio', rq);
  }

  setImmaginePortaleAdmin(rq: SetImmaginePortaleAdminRQ): Observable<SetImmaginePortaleAdminRS> {
    return this.post('Admin/UpdateImmaginePortale', rq);
  }

  getTariffaOTAXTipoCameraOTA(oid: number): Observable<WebApiResponse> {
    return this.get('TariffeOTAXTipiCameraOTA/' + oid);
  }

  getTariffeOTAXTipiCameraOTA(oid: number): Observable<WebApiResponse> {
    return this.get('Portali/' + oid + '/TariffeOTAXTipiCameraOTA');
  }

  getTariffeOTAXTipiCameraOTAFilter(oid: number, rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Portali/' + oid + '/TariffeOTAXTipiCameraOTA/Filter', rq);
  }

  setTariffaOTAXTipoCameraOTA(rq: TariffaOTAXTipoCameraOTA): Observable<WebApiResponseUpdate> {
    return this.post('TariffeOTAXTipiCameraOTA/Update', rq);
  }

  setTariffaOTAXTipoCameraOTAMultiple(rq: TariffaOTAXTipoCameraOTA[]): Observable<WebApiResponse> {
    return this.post('TariffeOTAXTipiCameraOTA/UpdateMultiple', rq);
  }

  public creaPromozione(rq: CreaPromozioneRQ): Observable<WebApiResponse> {
    return this.post('Promozioni/CreaPromozione', rq);
  }

  getPromozione(oid: number): Observable<WebApiResponse> {
    return this.get('Promozioni/' + oid);
  }

  getPromozioni(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Promozioni');
  }

  getPromozioniFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Promozioni/Filter', rq);
  }

  getPromozioniXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('Promozioni/PromozioniXLingua/Filter', WebApiRequestFilter.fromFilter('promozione.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setPromozione(rq: UpdatePromozioneRQ): Observable<UpdatePromozioneRS> {
    return this.post('Promozioni/Update', rq);
  }

  getBookingSolution(rq: BookingSolutionRQ): Observable<BookingSolutionRS> {
    return this.post('Booking/BookingSolution', rq);
  }

  getBookingSolutions(rq: BookingSolutionRQ[]): Observable<BookingSolutionsRS> {
    return this.post('Portali/BookingSolutions', rq);
  }

  getBookingExtraSolution(rq: BookingExtraSolutionRQ): Observable<BookingExtraSolutionRS> {
    return this.post('Booking/BookingExtraSolution', rq);
  }

  getPrezzoMinimoBooking(rq: GetPrezzoMinimoRQ): Observable<WebApiResponse> {
    return this.post('Booking/PrezzoMinimo', rq);
  }

  getPrezzoMinimoBookingV2(rq: GetPrezzoMinimoRQ): Observable<GetPrezzoMinimoBookingV2RS> {
    return this.post('Booking/PrezzoMinimoBookingV2', rq);
  }

  getPrezzoArticolo(rq: GetPrezzoArticoloRQ): Observable<GetPrezzoArticoloRS> {
    return this.post('Booking/PrezzoArticolo', rq);
  }

  getBookingSolutionConfig(rq: BookingSolutionConfigRQ): Observable<BookingSolutionConfigRS> {
    return this.post('Booking/BookingSolutionConfig', rq);
  }

  getDisponibilita(rq: GetDisponibilitaRQ): Observable<GetDisponibilitaRS> {
    return this.post('Booking/Disponibilita', rq);
  }

  getDisponibilitaNotti(rq: GetDisponibilitaNottiRQ): Observable<GetDisponibilitaNottiRS> {
    return this.post('Booking/DisponibilitaNotti', rq);
  }

  getCalendarioDisponibilitaCamere(rq: GetCalendarioDisponibilitaCamereRQ): Observable<GetCalendarioDisponibilitaCamereRS> {
    return this.post('Booking/CalendarioDisponibilitaCamere', rq);
  }

  createPrenotazione(rq: CreatePrenotazioneRQ): Observable<CreatePrenotazioneRS> {
    return this.post('Booking/CreatePrenotazione', rq);
  }

  saveCreatePrenotazione(rq: CreatePrenotazioneRQ): Observable<WebApiResponse> {
    return this.post('Booking/SaveCreatePrenotazione', rq);
  }

  createPrenotazioneExtra(rq: CreatePrenotazioneExtraRQ): Observable<WebApiResponse> {
    return this.post('Booking/CreatePrenotazioneExtra', rq);
  }

  createBuonoSconto(rq: CreateBuonoScontoRQ): Observable<WebApiResponse> {
    return this.post('Booking/CreateBuonoSconto', rq);
  }

  createPrenotazioneAccessori(rq: CreatePrenotazioneAccessoriRQ): Observable<WebApiResponse> {
    return this.post('Booking/CreatePrenotazioneAccessori', rq);
  }

  recuperaPassword(rq: RecuperaPasswordRQ): Observable<RecuperaPasswordRS> {
    return this.post('Clienti/RecuperaPassword', rq);
  }

  setAppuntamento(rq: ClienteAppuntamenti): Observable<WebApiResponseUpdate> {
    return this.post('Clienti/UpdateAppuntamento', rq);
  }

  getLingua(oid: number): Observable<WebApiResponse> {
    return this.get('Lingue/' + oid);
  }

  payment(rq: PaymentRQ): Observable<PaymentRS> {
    return this.post('Payment/Payment', rq);
  }

  getDmsSolution(rq: DmsSolutionRQ): Observable<DmsSolutionRS> {
    return this.post('Dms/DmsSolution', rq);
  }

  getDettagliPortale(rq: DettagliPortaleRQ): Observable<DettagliPortaleRS> {
    return this.post('Dms/DettagliPortale', rq);
  }

  getPortaliImmaginiServiziAlbergoMaster(rq: GetImmaginiPortaliServiziXAlbergoMasterRQ): Observable<GetImmaginiPortaliServiziXAlbergoMasterRS> {
    return this.post('Dms/PortaliImmaginiServizi', rq);
  }

  getServiziAlbergoMaster(oidAlbergo: number, rq: GetServiziRQ): Observable<WebApiResponse> {
    return this.post('AlbergoMaster/' + oidAlbergo + '/Servizi', rq);
  }

  getServizioDms(oid: number): Observable<WebApiResponse> {
    return this.get('ServiziDms/' + oid);
  }

  getServiziDms(oidAlbergo: number): Observable<WebApiResponse> {
    return this.get('AlbergoMaster/' + oidAlbergo + '/ServiziDms');
  }

  getPagineAlbergoMaster(oidAlbergo: number): Observable<WebApiResponse> {
    return this.get('AlbergoMaster/' + oidAlbergo + '/Pagine');
  }

  getPagineDms(rq: GetPagineDmsRQ): Observable<WebApiResponse> {
    return this.post('AlbergoMaster/PagineDms', rq);
  }

  getServiziDmsXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('ServiziDms/ServiziDmsXLingua/Filter', WebApiRequestFilter.fromFilter('servizioDms.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setServizioDms(rq: SetServiziDmsXLinguaRQ): Observable<WebApiResponse> {
    return this.post('ServiziDms/Update', rq);
  }

  getPagineAlbergoMasterXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('AlbergoMaster/PagineXLingua/Filter', WebApiRequestFilter.fromFilter('albergoMasterPagina.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setPaginaAlbergoMaster(rq: SetPagineAlbergoMasterXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('AlbergoMaster/UpdatePagina', rq);
  }

  getSistemazione(oid: number): Observable<WebApiResponse> {
    return this.get('Sistemazioni/' + oid);
  }

  getSistemazioni(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Sistemazioni');
  }

  getSistemazioniFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Sistemazioni/Filter', rq);
  }

  getSistemazioniXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('Sistemazioni/SistemazioniXLingua/Filter', WebApiRequestFilter.fromFilter('sistemazione.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setSistemazione(rq: SetSistemazioniXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('Sistemazioni/Update', rq);
  }

  getArticoli(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Articoli');
  }

  getArticoliFilter(rq: WebApiRequestFilter, oidAlbergo?: number): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + (oidAlbergo != null ? oidAlbergo : this.sessionService.getOidAlbergo()) + '/Articoli/Filter', rq);
  }

  getArticoliExtra(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ArticoliExtra');
  }

  getArticoliExtraFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ArticoliExtra/Filter', rq);
  }

  getServiziObbligatori(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ServiziObbligatori');
  }

  getServiziObbligatoriFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ServiziObbligatori/Filter', rq);
  }

  getAlberghiMasterXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('AlbergoMaster/AlberghiMasterXLingua/Filter', WebApiRequestFilter.fromFilter('albergoMaster.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  getLogOperazioni(rq: FiltroLogOperazione): Observable<WebApiResponseFilter> {
    return this.post('Log/Operazioni', rq);
  }

  getLogDisponibilita(rq: FiltroLogDisponibilita): Observable<WebApiResponseFilter> {
    return this.post('Log/Disponibilita', rq);
  }

  getTipiCameraOTAAlbergo(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/TipiCameraOTA');
  }

  getTariffeOTAAlbergo(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/TariffeOTA');
  }

  getTipiCameraOTAAlbergoViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/TipiCameraOTA/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getTariffeOTAAlbergoViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/TariffeOTA/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getApiKey(oid: number): Observable<WebApiResponse> {
    return this.get('AlbergoApiKeys/' + oid);
  }

  getApiKeysAdmin(): Observable<WebApiResponse> {
    return this.get('Admin/ApiKeys');
  }

  getApiKeysAdminFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Admin/ApiKeys/Filter', rq);
  }

  getApiKeys(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ApiKeys');
  }

  getApiKeysFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ApiKeys/Filter', rq);
  }

  setApiKey(rq: AlbergoApiKeys): Observable<WebApiResponse> {
    return this.post('AlbergoApiKeys/Update', rq);
  }

  getLogRicerche(rq: GetRicercheRQ): Observable<GetRicercheRS> {
    return this.post('Log/Ricerche', rq);
  }

  getLogOperazionePortaleS3(rq: GetLogOperazioneDettagliRQ): Observable<GetLogOperazioneDettagliRS> {
    return this.post('Log/LogOperazionePortaleS3', rq);
  }

  getPrezzi(): Observable<GetPrezziRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Prezzi');
  }

  getPrezziFilter(rq: WebApiRequestFilter): Observable<GetPrezziRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Prezzi/Filter', rq);
  }

  getViewFormV1(rq: GetFormV1ViewRQ): Observable<GetFormV1ViewRS> {
    return this.post('Booking/ViewFormV1', rq);
  }

  /*attivaMyForecast(rq: AttivaMyForecastRQ): Observable<AttivaMyForecastRS> {
    return this.post('MyForecast/Attiva', rq);
  }

  aggiornaMyForecast(rq: AttivaMyForecastRQ): Observable<AggiornaMyForecastRS> {
    return this.post('MyForecast/Aggiorna', rq);
  }

  aggiornaSorgentiMyForecast(rq: AggiornaSorgentiMyForecastRQ): Observable<AggiornaSorgentiMyForecastRS> {
    return this.post('MyForecast/AggiornaSorgenti', rq);
  }

  leggiStrutturaMyForecast(rq: LeggiStrutturaMyForecastRQ): Observable<LeggiStrutturaMyForecastRS> {
    return this.post('MyForecast/LeggiStruttura', rq);
  }

  leggiRisorseMyForecast(rq: LeggiRisorseMyForecastRQ): Observable<LeggiRisorseMyForecastRS> {
    return this.post('MyForecast/LeggiRisorse', rq);
  }

  leggiSorgentiMyForecast(rq: LeggiSorgentiMyForecastRQ): Observable<LeggiSorgentiMyForecastRS> {
    return this.post('MyForecast/LeggiSorgenti', rq);
  }*/

  getRisorsePortale(oidPortale: number): Observable<RisorseRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Risorse', new RisorseRQ(oidPortale));
  }

  importaRisorse(rq: ImportaRisorseRQ): Observable<ImportaRisorseRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ImportaRisorsePortale', rq);
  }

  getTariffePortale(oidPortale: number): Observable<TariffeRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Tariffe', new TariffeRQ(oidPortale));
  }

  importaTariffe(rq: ImportaTariffeRQ): Observable<ImportaTariffeRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ImportaTariffePortale', rq);
  }

  getTotaliDashboard(rq: GetDashboardRQ): Observable<GetTotaliPrenotazioniDashboardRS> {
    return this.post('Dashboard/Totali', rq);
  }

  getInfoDashboard(rq: GetDashboardRQ): Observable<GetInfoDashboardRS> {
    return this.post('Dashboard/Info', rq);
  }

  getPrenotazioniDashboard(rq: GetDashboardRQ): Observable<GetPrenotazioniDashboardRS> {
    return this.post('Dashboard/Prenotazioni', rq);
  }

  getPreventiviDashboard(rq: GetDashboardRQ): Observable<GetPreventiviDashboardRS> {
    return this.post('Dashboard/Preventivi', rq);
  }

  getDisponibilitaDashboard(rq: GetDashboardRQ): Observable<GetDisponibilitaDashboardRS> {
    return this.post('Dashboard/Disponibilita', rq);
  }

  getDisponibilitaPrezziDashboard(rq: GetDashboardRQ): Observable<GetDisponibilitaPrezziDashboardRS> {
    return this.post('Dashboard/DisponibilitaPrezzi', rq);
  }

  getNotificheEmailDashboard(rq: GetDashboardRQ): Observable<GetNotificheEmailDashboardRS> {
    return this.post('Dashboard/NotificheEmail', rq);
  }

  getChiusureGiornaliereDashboard(rq: GetDashboardRQ): Observable<GetChiusureGiornaliereDashboardRS> {
    return this.post('Dashboard/ChiusureGiornaliere', rq);
  }

  getAlberghiDashboardAdmin(rq: GetDashboardAdminRQ): Observable<GetAlberghiDashboardAdminRS> {
    return this.post('DashboardAdmin/Alberghi', rq);
  }

  getPrenotazioniDashboardAdmin(rq: GetDashboardAdminRQ): Observable<GetPrenotazioniDashboardAdminRS> {
    return this.post('DashboardAdmin/Prenotazioni', rq);
  }

  getPreventiviDashboardAdmin(rq: GetDashboardAdminRQ): Observable<GetNumeroPreventiviDashboardAdminRS> {
    return this.post('DashboardAdmin/Preventivi', rq);
  }

  getNotificheEmailDashboardAdmin(rq: GetDashboardAdminRQ): Observable<GetNotificheEmailDashboardAdminRS> {
    return this.post('DashboardAdmin/NotificheEmail', rq);
  }

  getPortaliDashboardAdmin(rq: GetDashboardAdminRQ): Observable<GetPortaliDashboardAdminRS> {
    return this.post('DashboardAdmin/Portali', rq);
  }

  getErroriDashboardAdmin(rq: GetDashboardAdminRQ): Observable<GetErroriDashboardAdminRS> {
    return this.post('DashboardAdmin/Errori', rq);
  }

  getTransazioniDashboardAdmin(rq: GetDashboardAdminRQ): Observable<GetTransazioniDashboardAdminRS> {
    return this.post('DashboardAdmin/Transazioni', rq);
  }

  getSondaggiDashboardAdmin(rq: GetDashboardAdminRQ): Observable<GetNumeroSondaggiDashboardAdminRS> {
    return this.post('DashboardAdmin/Sondaggi', rq);
  }

  getFasce(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Fasce');
  }

  getFasceFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Fasce/Filter', rq);
  }

  sendTestEmail(oid: number): Observable<SendTestEmailRS> {
    return this.get('AccountMail/' + oid + '/InviaEmailTest');
  }

  getAccountMail(oid: number): Observable<WebApiResponse> {
    return this.get('AccountMail/' + oid);
  }

  getAccountMailList(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/AccountMail');
  }

  getAccountMailListFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/AccountMail/Filter', rq);
  }

  setAccountMail(rq: AccountMail): Observable<WebApiResponseUpdate> {
    return this.post('AccountMail/Update', rq);
  }

  getSondaggio(oid: number): Observable<WebApiResponse> {
    return this.get('Sondaggi/' + oid);
  }

  getSondaggi(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Sondaggi');
  }

  getSondaggiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Sondaggi/Filter', rq);
  }

  getSondaggiXLingua(oid: number): Observable<GetSondaggiXLinguaRS> {
    return this.get('Sondaggi/' + oid + '/SondaggiXLingua');
  }

  setSondaggio(rq: SetSondaggiXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('Sondaggi/Update', rq);
  }

  setRispostaSondaggio(rq: SondaggioRisposta): Observable<WebApiResponseUpdate> {
    return this.post('Sondaggi/UpdateRisposta', rq);
  }

  getRisposteSondaggi(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/RisposteSondaggi');
  }

  getRisposteSondaggiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/RisposteSondaggi/Filter', rq);
  }

  getComponenteXVariazione(oid: number): Observable<WebApiResponse> {
    return this.get('ComponentiXVariazione/' + oid);
  }

  getComponentiXVariazione(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ComponentiXVariazione');
  }

  getComponentiXVariazioneFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ComponentiXVariazione/Filter', rq);
  }

  getComponentiXVariazioneXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('ComponentiXVariazione/ComponentiXVariazioneXLingua/Filter', WebApiRequestFilter.fromFilter('componenteXVariazione.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setComponenteXVariazione(rq: SetComponentiXVariazioneXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('ComponentiXVariazione/Update', rq);
  }

  getRisorseCollegateComponenteXVariazione(oid: number): Observable<WebApiResponse> {
    return this.get('ComponentiXVariazione/' + oid + '/RisorseCollegate');
  }

  getWebHook(oid: number): Observable<WebApiResponse> {
    return this.get('WebHooks/' + oid);
  }

  getWebHooks(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/WebHooks');
  }

  getWebHooksFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/WebHooks/Filter', rq);
  }

  setWebHook(rq: WebHooks): Observable<WebApiResponse> {
    return this.post('WebHooks/Update', rq);
  }

  getWorkFlow(oid: number): Observable<WebApiResponse> {
    return this.get('WorkFlows/' + oid);
  }

  getWorkFlowDetail(oid: number): Observable<WorkFlowDetailRS> {
    return this.get('WorkFlows/' + oid + '/Detail');
  }

  getNotificheEmailWorkFlow(oid: number): Observable<WebApiResponse> {
    return this.get('WorkFlows/' + oid + '/NotificheEmail');
  }

  getWorkFlows(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/WorkFlows');
  }

  getWorkFlowsFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/WorkFlows/Filter', rq);
  }

  setWorkFlow(rq: WorkFlow): Observable<WebApiResponse> {
    return this.post('WorkFlows/Update', rq);
  }

  setWorkFlows(rq: WorkFlow[]): Observable<WebApiResponse> {
    return this.post('WorkFlows/UpdateMultiple', rq);
  }

  getTemplatesViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true, oidAlbergo?: number): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + (oidAlbergo != null ? oidAlbergo : this.sessionService.getOidAlbergo()) + '/Templates/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getSondaggiViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Sondaggi/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getModalitaPagamentoViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ModalitaPagamento/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getImmaginiRisorsePortale(oid: number): Observable<WebApiResponse> {
    return this.get('Portali/' + oid + '/ImmaginiRisorse');
  }

  sincronizzaDisponibilita(rq: SincronizzaDisponibilitaRQ): Observable<WebApiResponse> {
    return this.post('Portali/SincronizzaDisponibilita', rq);
  }

  getTransazione(oid: number, showError: boolean = true): Observable<WebApiResponse> {
    return this.get('Transazioni/' + oid, showError);
  }

  updateTransazione(rq: Transazione): Observable<WebApiResponseUpdate> {
    return this.post('Transazioni/Update', rq);
  }

  eseguiWorkFlowPreventivo(rq: EseguiWorkFlowPreventivoRQ): Observable<EseguiWorkFlowPreventivoRS> {
    return this.post('Preventivi/EseguiWorkFlow', rq);
  }

  getWorkFlowsPreventivo(oidPreventivo: number): Observable<WebApiResponse> {
    return this.get('Preventivi/' + oidPreventivo + '/WorkFlows');
  }

  verificaCartaCredito(rq: VerificaCartaCreditoRQ): Observable<VerificaCartaCreditoRS> {
    return this.post('Booking/VerificaCartaCredito', rq);
  }

  getAttivitaAutomatica(oid: number): Observable<WebApiResponse> {
    return this.get('BackgroundWorker/' + oid);
  }

  getAttivitaAutomaticheAdmin(): Observable<WebApiResponse> {
    return this.get('Admin/AttivitaAutomatiche');
  }

  getAttivitaAutomaticheAdminFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Admin/AttivitaAutomatiche/Filter', rq);
  }

  getAttivitaAutomatiche(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/AttivitaAutomatiche');
  }

  getAttivitaAutomaticheFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/AttivitaAutomatiche/Filter', rq);
  }

  setAttivitaAutomatica(rq: BackgroundWorker): Observable<WebApiResponse> {
    return this.post('BackgroundWorker/Update', rq);
  }

  inviaSms(rq: SendSmsRQ): Observable<SendSmsRS> {
    return this.post('Sms/Invia', rq);
  }

  getTipiCarteTrentino(rq: TrentinoGetTipiCarteRQ): Observable<TrentinoGetTipiCarteRS> {
    return this.post('Trentino/GetTipiCarte', rq);
  }

  leggiCarteTrentino(rq: TrentinoLeggiCarteRQ): Observable<TrentinoLeggiCarteRS> {
    return this.post('Trentino/LeggiCarte', rq);
  }

  emettiCartaTrentino(rq: TrentinoEmettiCartaRQ): Observable<TrentinoEmettiCartaRS> {
    return this.post('Trentino/EmettiCarta', rq);
  }

  attivaDisattivaCartaTrentino(rq: TrentinoAttivaDisattivaCartaRQ): Observable<TrentinoAttivaDisattivaCartaRS> {
    return this.post('Trentino/AttivaDisattivaCarta', rq);
  }

  modificaCartaTrentino(rq: TrentinoModificaCartaRQ): Observable<TrentinoModificaCartaRS> {
    return this.post('Trentino/ModificaCarta', rq);
  }

  verificaCodicePromozionale(rq: VerificaCodicePromozioneRQ): Observable<VerificaCodicePromozioneRS> {
    return this.post('Booking/VerificaCodicePromozionale', rq);
  }

  verificaVoucher(rq: VerificaVoucherRQ): Observable<VerificaVoucherRS> {
    return this.post('Booking/VerificaVoucher', rq);
  }

  getUpSelling(oid: number): Observable<WebApiResponse> {
    return this.get('UpSelling/' + oid);
  }

  getUpSellings(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/UpSelling');
  }

  getUpSellingsFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/UpSelling/Filter', rq);
  }

  getUpSellingsXLingua(oid: number): Observable<WebApiResponseFilter> {
    return this.post('UpSelling/UpSellingXLingua/Filter', WebApiRequestFilter.fromFilter('upSelling.oid', CriteriaOperator.Equal, oid.toString(), FilterValueType.Number));
  }

  setUpSelling(rq: SetUpSellingXLinguaRQ): Observable<WebApiResponseUpdateDetails> {
    return this.post('UpSelling/Update', rq);
  }

  setRichiestaUpSelling(rq: PrenotazioneUpSelling): Observable<WebApiResponseUpdate> {
    return this.post('UpSelling/UpdateRichiesta', rq);
  }

  getUpSellingsRichiesti(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/UpSellingRichiesti');
  }

  getUpSellingsRichiestiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/UpSellingRichiesti/Filter', rq);
  }

  getArticoliMySelf(rq: GetArticoliMySelfRQ): Observable<WebApiResponse> {
    return this.post('MySelf/GetArticoli', rq);
  }

  getPrenotazioneDetailsMySelf(rq: GetPrenotazioneDetailsMySelfRQ): Observable<GetPrenotazioneDetailsMySelfRS> {
    return this.post('MySelf/GetPrenotazioneDetails', rq);
  }

  ordinaPiattiMySelf(rq: OrdinaPiattiMySelfRQ): Observable<WebApiResponse> {
    return this.post('MySelf/OrdinaPiatti', rq);
  }

  cancellaOrdinePiattiMySelf(rq: CancellaOrdinePiattiMySelfRQ): Observable<WebApiResponse> {
    return this.post('MySelf/CancellaOrdinePiatti', rq);
  }

  creaPrenotazioneExtraSelfCheckin(rq: CreaPrenotazioneExtraRQ): Observable<CreaPrenotazioneExtraRS> {
    if (rq.articoli != null) {
      rq.articoli = JSON.parse(JSON.stringify(rq.articoli));

      rq.articoli.forEach(x => {
        x.totale = undefined;
        x.prezzo = undefined;
        x.prezzoPieno = undefined;
        x.sconto = undefined;

        if (x.giorni != null) {
          x.giorni.forEach(y => y.prezzo = undefined);
        }
      });
    }

    return this.post('MySelf/CreaPrenotazioneExtra', rq);
  }

  richiediCancellazionePrenotazione(rq: RichiediCancellazionePrenotazioneRQ): Observable<WebApiResponse> {
    return this.post('MySelf/RichiediCancellazionePrenotazione', rq);
  }

  richiediUpSellingPrenotazione(rq: RichiediUpSellingPrenotazioneRQ): Observable<RichiediUpSellingPrenotazioneRS> {
    return this.post('MySelf/RichiediUpSellingPrenotazione', rq);
  }

  getPortaleXAlbergoForm(oid: number): Observable<GetPortaleXAlbergoFormRS> {
    return this.get('Portali/' + oid + '/GetPortaleXAlbergoForm');
  }

  updatePaxPreventivo(rq: UpdatePaxPreventivoRQ): Observable<WebApiResponse> {
    return this.post('Preventivi/UpdatePax', rq);
  }

  updatePaxRichiesta(rq: UpdatePaxRichiestaRQ): Observable<WebApiResponse> {
    return this.post('Richieste/UpdatePax', rq);
  }

  qualitelisInviaPrenotazioni(rq: QualitelisInviaPrenotazioniRQ): Observable<QualitelisInviaPrenotazioniRS> {
    return this.post('Qualitelis/InviaPrenotazioni', rq);
  }

  scrollideaInviaPrenotazioni(rq: ScrollideaInviaPrenotazioniRQ): Observable<ScrollideaInviaPrenotazioniRS> {
    return this.post('Scrollidea/InviaPrenotazioni', rq);
  }

  trustyouInviaPrenotazioni(rq: TrustyouInviaPrenotazioniRQ): Observable<TrustyouInviaPrenotazioniRS> {
    return this.post('Trustyou/InviaPrenotazioni', rq);
  }

  philipsCMNDInviaPrenotazioni(rq: PhilipsCMNDInviaPrenotazioniRQ): Observable<PhilipsCMNDInviaPrenotazioniRS> {
    return this.post('PhilipsCMND/InviaPrenotazioni', rq);
  }

  /*hoauInviaPrenotazioni(rq: HoauInviaPrenotazioniRQ): Observable<HoauInviaPrenotazioniRS> {
    return this.post('Hoau/InviaPrenotazioni', rq);
  }*/

  mailchimpInviaClienti(rq: MailchimpInviaClientiRQ): Observable<MailchimpInviaClientiRS> {
    return this.post('Mailchimp/InviaClienti', rq);
  }

  mailchimpInviaClientiBulk(rq: MailchimpInviaClientiRQ): Observable<MailchimpInviaClientiRS> {
    return this.post('Mailchimp/InviaClientiBulk', rq);
  }

  activeCampaignInviaClienti(rq: ActiveCampaignInviaClientiRQ): Observable<ActiveCampaignInviaClientiRS> {
    return this.post('ActiveCampaign/InviaClienti', rq);
  }

  activeCampaignInviaClientiBulk(rq: ActiveCampaignInviaClientiRQ): Observable<ActiveCampaignInviaClientiRS> {
    return this.post('ActiveCampaign/InviaClientiBulk', rq);
  }

  hubSpotInviaClienti(rq: HubSpotInviaClientiRQ): Observable<HubSpotInviaClientiRS> {
    return this.post('HubSpot/InviaClienti', rq);
  }

  hubSpotInviaClientiBulk(rq: HubSpotInviaClientiRQ): Observable<HubSpotInviaClientiRS> {
    return this.post('HubSpot/InviaClientiBulk', rq);
  }

  testMail(rq: TestMailRQ): Observable<WebApiResponse> {
    return this.post('Dev/TestMail', rq);
  }

  getPrenotazioniAssociate(oid: number): Observable<GetPrenotazioniAssociateRS> {
    return this.get('Prenotazioni/' + oid + '/Prenotazioni');
  }

  getAddebitiPrenotazione(oid: number): Observable<WebApiResponse> {
    return this.get('Prenotazioni/' + oid + '/Addebiti');
  }

  importaPrenotazioni(prenotazioni: Prenotazione[]): Observable<WebApiResponse> {
    return this.post('Prenotazioni/Importa', prenotazioni);
  }

  sbloccaAccount(oid: number): Observable<WebApiResponse> {
    return this.get('Albergo/' + oid + '/SbloccaAccount');
  }

  getAccessi(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getCodiceAlbergo() + '/Accessi');
  }

  getAccessiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getCodiceAlbergo() + '/Accessi/Filter', rq);
  }

  getErroriPortali(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ErroriPortali');
  }

  getErroriPortaliFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ErroriPortali/Filter', rq);
  }

  getErroriPortaliPartner(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getCodicePartner() + '/ErroriPortaliPartner');
  }

  getErroriPortaliPartnerFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getCodicePartner() + '/ErroriPortaliPartner/Filter', rq);
  }

  getLogApiKeys(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/LogApiKeys');
  }

  getLogApiKeysFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/LogApiKeys/Filter', rq);
  }

  getAlberghiMasterAlbergo(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/AlberghiMaster');
  }

  getAlberghiMasterAlbergoFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/AlberghiMaster/Filter', rq);
  }

  copiaDisponibilita(rq: CopiaDisponibilitaRQ): Observable<WebApiResponse> {
    return this.post('Disponibilita/CopiaDisponibilita', rq);
  }

  getMail(oid: number, rq: GetMailRQ): Observable<GetMailRS> {
    return this.post('AccountMail/' + oid + '/GetMail', rq);
  }

  getMailFolder(oid: number, rq: GetMailRQ): Observable<GetMailRS> {
    return this.post('AccountMail/' + oid + '/GetMailFolder', rq);
  }

  searchMail(oid: number, rq: GetMailRQ): Observable<GetMailRS> {
    return this.post('AccountMail/' + oid + '/SearchMail', rq);
  }

  deleteMail(oid: number, rq: DeleteMailRQ): Observable<WebApiResponse> {
    return this.post('AccountMail/' + oid + '/DeleteMail', rq);
  }

  setMailAsSeen(oid: number, rq: SetMailAsSeenRQ): Observable<WebApiResponse> {
    return this.post('AccountMail/' + oid + '/SetMailAsSeen', rq);
  }

  moveMail(oid: number, rq: MoveMailRQ): Observable<WebApiResponse> {
    return this.post('AccountMail/' + oid + '/MoveMail', rq);
  }

  sendEmailAccountMail(oid: number, rq: SendMailRQ): Observable<SendMailRS> {
    return this.post('AccountMail/' + oid + '/SendMail', rq);
  }

  sendEmailTemplate(oid: number, rq: SendMailRQ): Observable<SendMailRS> {
    return this.post('Templates/' + oid + '/SendMail', rq);
  }

  getErroriAlbergo(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Errori');
  }

  checkTemplatesPrenotazione(): Observable<CheckTemplatesPrenotazioneRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/CheckTemplatesPrenotazione');
  }

  getCreaPrenotazioneTransazioneRQ(oid: number): Observable<CreaPrenotazioneTransazioneRQ> {
    return this.get('Transazioni/' + oid + '/GetCreaPrenotazioneTransazioneRQ');
  }

  creaPrenotazioneTransazione(rq: CreaPrenotazioneTransazioneRQ): Observable<CreaPrenotazioneTransazioneRS> {
    return this.post('Prenotazioni/CreaPrenotazioneTransazione', rq);
  }

  getStorico(rq: GetStoricoRQ): Observable<GetStoricoRS> {
    return this.post('Admin/Storico', rq);
  }

  getPrenotazioniWS(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/PrenotazioniWS');
  }

  getPrenotazioniWSFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/PrenotazioniWS/Filter', rq);
  }

  getAllegati(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/Allegati');
  }

  getAllegatiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Allegati/Filter', rq);
  }

  getUnsubscribe(rq: GetUnsubscribeRQ): Observable<GetUnsubscribeRS> {
    return this.post('Booking/ClienteUnsubscribe', rq);
  }

  archiviaPreventivi(rq: ArchiviaPreventiviRQ): Observable<WebApiResponse> {
    return this.post('Preventivi/ArchiviaPreventivi', rq);
  }

  cancellaPreventivi(rq: CancellaPreventiviRQ): Observable<WebApiResponse> {
    return this.post('Preventivi/CancellaPreventivi', rq);
  }

  inviaMessaggioPreventivi(rq: InviaMessaggioPreventiviRQ): Observable<WebApiResponse> {
    return this.post('Preventivi/InviaMessaggioPreventivi', rq);
  }

  getTagsTemplate(rq: GetTagsTemplateRQ): Observable<WebApiResponse> {
    return this.post('Templates/Tags', rq);
  }

  getRecensioniPortale(rq: GetRecensioniRQ): Observable<WebApiResponse> {
    return this.post('Booking/Recensioni', rq);
  }

  sbloccaUtente(oid: number): Observable<WebApiResponse> {
    return this.get('Utenti/' + oid + '/Sblocca');
  }

  sbloccaCliente(oid: number): Observable<WebApiResponse> {
    return this.get('Clienti/' + oid + '/Sblocca');
  }

  sbloccaClienti(rq: SbloccaClientiRQ): Observable<WebApiResponse> {
    return this.post('Clienti/SbloccaTutti', rq);
  }

  loginUtente(rq: LoginUtenteRQ): Observable<WebApiResponse> {
    return this.post('Utenti/Login', rq);
  }

  getStoricoCliente(oid: number): Observable<WebApiResponse> {
    return this.get('Clienti/' + oid + '/Storico');
  }

  getPreventiviCliente(rq: GetPreventiviClienteRQ): Observable<WebApiResponse> {
    return this.post('Clienti/Preventivi', rq);
  }

  updateDettagliFromBookingSolution(rq: UpdateDettagliFromBookingSolutionRQ): Observable<WebApiResponse> {
    return this.post('Preventivi/UpdateDettagliFromBookingSolution', rq);
  }

  duplicaTemplate(oid: number): Observable<WebApiResponse> {
    return this.get('Templates/' + oid + '/Duplica');
  }

  duplicaPreventivo(oid: number): Observable<WebApiResponse> {
    return this.get('Preventivi/' + oid + '/Duplica');
  }

  duplicaTagCrm(oid: number): Observable<WebApiResponse> {
    return this.get('TagCrm/' + oid + '/Duplica');
  }

  getImmaginiTagCrm(oid: number): Observable<WebApiResponse> {
    return this.get('TagCrm/' + oid + '/Immagini');
  }

  duplicaModalitaPagamento(oid: number): Observable<WebApiResponse> {
    return this.get('ModalitaPagamento/' + oid + '/Duplica');
  }

  duplicaBanner(oid: number): Observable<WebApiResponse> {
    return this.get('Banner/' + oid + '/Duplica');
  }

  duplicaCodicePromozione(oid: number): Observable<WebApiResponse> {
    return this.get('CodiciPromozione/' + oid + '/Duplica');
  }

  duplicaPromozione(oid: number): Observable<WebApiResponse> {
    return this.get('Promozioni/' + oid + '/Duplica');
  }

  setErroreEsaminato(rq: SetErroreEsaminatoRQ): Observable<WebApiResponse> {
    return this.post('Dashboard/SetErroreEsaminato', rq);
  }

  authenticateWelcome(rq: WelcomeServerAuthenticateRQ): Observable<WelcomeServerAuthenticateRS> {
    return this.post('SmartCloud/Authenticate', rq);
  }

  testConnessioneWelcome(rq: WelcomeServerRequest): Observable<WebApiResponse> {
    return this.post('SmartCloud/TestConnessione', rq);
  }

  getCamereLibereWelcome(rq: GetCamereLibereWelcomeRQ): Observable<GetCamereLibereWelcomeRS> {
    return this.post('SmartCloud/CamereLibere', rq);
  }

  getQuadroGraficoAccessoriWelcome(rq: GetQuadroGraficoAccessoriWelcomeRQ): Observable<GetQuadroGraficoAccessoriWelcomeRS> {
    return this.post('SmartCloud/QuadroGraficoAccessori', rq);
  }

  getQuantitaMassimaGiornalieraSupplementoWelcome(rq: GetQuantitaMassimaGiornalieraSupplementoWelcomeRQ): Observable<GetQuantitaMassimaGiornalieraSupplementoWelcomeRS> {
    return this.post('SmartCloud/GetQuantitaMassimaGiornalieraSupplemento', rq);
  }

  getQuantitaMassimaGiornalieraSupplementiWelcome(rq: GetQuantitaMassimaGiornalieraSupplementiWelcomeRQ): Observable<GetQuantitaMassimaGiornalieraSupplementiWelcomeRS> {
    return this.post('SmartCloud/GetQuantitaMassimaGiornalieraSupplementi', rq);
  }

  downloadRichiesteInfoAlberghi(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/DownloadRichiesteInfoAlberghi');
  }

  getMotiviViaggioViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/MotiviViaggio/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getMenuViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Menu/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getCategoriePiattiViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/CategoriePiatti/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getPiattiViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Piatti/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getRiduzioniViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Riduzioni/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getSistemazioniViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/Sistemazioni/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getCodiciPartner(): Observable<WebApiResponse> {
    return this.get('Admin/CodiciPartner');
  }

  getInfoDisponibilita(oid: number): Observable<WebApiResponse> {
    return this.get('Disponibilita/' + oid + '/GetInfo');
  }

  impostaPrenotazioneExtraVisualizzata(oid: number): Observable<WebApiResponse> {
    return this.get('PrenotazioniExtra/' + oid + '/ImpostaVisualizzata');
  }

  confermaErrori(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ConfermaErrori');
  }

  testConnectionPortaleXAlbergo(oidPortale: number): Observable<TestConnectionRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/TestConnectionPortaleXAlbergo', new TestConnectionRQ(oidPortale));
  }

  getCalendarioMenuView(rq: GetCalendarioMenuViewRQ): Observable<GetCalendarioMenuViewRS> {
    return this.post('MySelfConfigurazione/GetCalendarioMenuView', rq);
  }

  getCalendarioMenu(rq: GetCalendarioMenuRQ): Observable<GetCalendarioMenuRS> {
    return this.post('MySelfConfigurazione/GetCalendarioMenu', rq);
  }

  setMenuGiorno(rq: UbicazioneIstatMenu): Observable<WebApiResponse> {
    return this.post('MySelfConfigurazione/SetMenuGiorno', rq);
  }

  setMenuGiornoMultiple(rq: ModificaMultiplaMenuGiorniRQ): Observable<WebApiResponse> {
    return this.post('MySelfConfigurazione/SetMenuGiornoMultiple', rq);
  }

  setPrenotazioneConteggioPiatti(rq: PrenotazioneConteggioPiatti): Observable<WebApiResponseUpdate> {
    return this.post('MySelfConfigurazione/UpdatePrenotazioneConteggioPiatti', rq);
  }

  eseguiWorkFlowPrenotazione(rq: EseguiWorkFlowPrenotazioneRQ): Observable<EseguiWorkFlowPrenotazioneRS> {
    return this.post('Prenotazioni/EseguiWorkFlow', rq);
  }

  getAlberghiCrs(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/AlberghiCrs');
  }

  getAlberghiCrsFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/AlberghiCrs/Filter', rq);
  }

  setAlbergoCrs(rq: AlbergoCrs): Observable<WebApiResponseUpdate> {
    return this.post('Crs/UpdateAlbergoCrs', rq);
  }

  getPrenotazioniCrs(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Crs/Prenotazioni', rq);
  }

  getTrasferisciPrenotazioniView(rq: GetTrasferisciPrenotazioniViewRQ): Observable<GetTrasferisciPrenotazioniViewRS> {
    return this.post('Crs/TrasferisciPrenotazioniView', rq);
  }

  trasferisciPrenotazioni(rq: TrasferisciPrenotazioniRQ): Observable<WebApiResponse> {
    return this.post('Crs/TrasferisciPrenotazioni', rq);
  }

  getDisponibiliCrs(rq: GetDisponibiliCrsRQ): Observable<GetDisponibiliCrsRS> {
    return this.post('Crs/GetDisponibili', rq);
  }

  getPlanningDisponibilitaCrs(rq: GetPlanningDisponibilitaCrsRQ): Observable<GetPlanningDisponibilitaCrsRS> {
    return this.post('Crs/GetPlanningDisponibilita', rq);
  }

  getPromozioneDetails(oid: number): Observable<DetailPromozioneRS> {
    return this.get('Promozioni/' + oid + '/Detail');
  }

  getTariffeCollegatePromozione(oid: number): Observable<WebApiResponse> {
    return this.get('Promozioni/' + oid + '/TariffeCollegate');
  }

  getConteggioPiatti(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/ConteggioPiatti');
  }

  getConteggioPiattiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/ConteggioPiatti/Filter', rq);
  }

  getListinoDetails(oid: number): Observable<DetailListinoRS> {
    return this.get('Listini/' + oid + '/Detail');
  }

  getModalitaPagamentoGestPay(rq: GetModalitaPagamentoGestPayRQ): Observable<WebApiResponse> {
    return this.post('Booking/GetModalitaPagamentoGestPay', rq);
  }

  getTransazioneById(rq: GetTransazioneByIdRQ): Observable<WebApiResponse> {
    return this.post('Transazioni/GetById', rq);
  }

  getTransazioneStartsWithId(rq: GetTransazioneByIdRQ): Observable<WebApiResponse> {
    return this.post('Transazioni/StartsWithId', rq);
  }

  anonimizzaCliente(oid: number): Observable<WebApiResponse> {
    return this.get('Clienti/' + oid + '/Anonimizza');
  }

  getStatoPubblicazionePortali(rq: GetStatoPubblicazionePortaliRQ): Observable<WebApiResponse> {
    return this.post('Disponibilita/GetStatoPubblicazionePortali', rq);
  }

  getUpgradeGratuiti(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/UpgradeGratuiti');
  }

  registraCliente(rq: RegistraClienteRQ): Observable<WebApiResponse> {
    return this.post('Clienti/RegistraCliente', rq);
  }

  getPasswordCliente(rq: GetPasswordClienteRQ): Observable<WebApiResponse> {
    return this.post('Clienti/GetPasswordCliente', rq);
  }

  getTariffePortaliCollegati(oidPortale: number): Observable<WebApiResponse> {
    return this.get('Portali/' + oidPortale + '/TariffePortaliCollegati');
  }

  collegaTariffePortaleMaster(rq: CollegaTariffePortaleMasterRQ): Observable<WebApiResponse> {
    return this.post('Portali/CollegaTariffePortaleMaster', rq);
  }

  getVariazioniTassa(oid: number): Observable<GetVariazioniTassaRS> {
    return this.get('Trattamenti/' + oid + '/GetVariazioniTassa');
  }

  getModificaBlocchiForm(oidPortale: number): Observable<GetModificaBlocchiFormRS> {
    return this.get('Portali/' + oidPortale + '/GetModificaBlocchiForm');
  }

  getVariazioniXPeriodoPortaleMaster(oidPortale: number): Observable<WebApiResponse> {
    return this.get('Portali/' + oidPortale + '/GetVariazioniXPeriodo');
  }

  setVariazioneXPeriodoPortaleMaster(rq: PortaleXAlbergoVariazioni): Observable<WebApiResponseUpdate> {
    return this.post('Portali/SetVariazioneXPeriodo', rq);
  }

  setVariazioniXPeriodoPortaleMaster(rq: SetVariazioniXPeriodoPortaleMasterRQ): Observable<WebApiResponseUpdate> {
    return this.post('Portali/SetVariazioniXPeriodo', rq);
  }

  ricalcolaPropostePreventivo(rq: RicalcolaPropostePreventivoRQ): Observable<WebApiResponse> {
    return this.post('Preventivi/RicalcolaProposte', rq);
  }

  getRisorseTariffePromozioniCollegateSupplemento(oid: number): Observable<GetRisorseTariffePromozioniCollegateSupplementoRS> {
    return this.get('Supplementi/' + oid + '/RisorseTariffePromozioniCollegate');
  }

  controllaCollegamentiPoliticaCancellazione(oid: number): Observable<GetCollegamentiPoliticaCancellazioneRS> {
    return this.get('Cancellazioni/' + oid + '/ControllaCollegamenti');
  }

  duplicaWorkflow(oid: number): Observable<WebApiResponse> {
    return this.get('WorkFlows/' + oid + '/Duplica');
  }

  deleteBookingSolution(rq: DeleteBookingSolutionRQ): Observable<WebApiResponse> {
    return this.post('Booking/DeleteBookingSolution', rq);
  }

  generaCodiceGoogleAuthenticator(oidUtente: number): Observable<GeneraCodiceGoogleAuthenticatorRS> {
    return this.get('Utenti/' + oidUtente + '/GeneraCodiceGoogleAuthenticator');
  }

  verificaPinGoogleAuthenticator(rq: VerificaPinGoogleAuthenticatorRQ): Observable<WebApiResponse> {
    return this.post('Utenti/VerificaPinGoogleAuthenticator', rq);
  }

  generaTokenAirbnb(rq: GeneraTokenAirbnbRQ): Observable<WebApiResponse> {
    return this.post('Portali/GeneraTokenAirbnb', rq);
  }

  getConfigurazioneTipoCameraAirbnb(oidTipoCamera: number): Observable<GetConfigurazioneTipoCameraAirbnbRS> {
    return this.get('TipiCamereOTA/' + oidTipoCamera + '/GetConfigurazioneAirbnb');
  }

  setConfigurazioneTipoCameraAirbnb(oidTipoCamera: number, rq: ConfigurazioneTipoCameraAirbnb): Observable<WebApiResponse> {
    return this.post('TipiCamereOTA/' + oidTipoCamera + '/SetConfigurazioneAirbnb', rq);
  }

  getAnnuncioAirbnb(oidTipoCamera: number): Observable<GetConfigurazioneAnnuncioAirbnbRS> {
    return this.get('TipiCamereOTA/' + oidTipoCamera + '/GetListingAirbnb');
  }

  setAnnuncioAirbnb(oidTipoCamera: number, rq: ConfigurazioneAnnuncioAirbnb): Observable<SetAnnuncioAirbnbRS> {
    return this.post('TipiCamereOTA/' + oidTipoCamera + '/SetListingAirbnb', rq);
  }

  deleteAnnuncioAirbnb(oidTipoCamera: number): Observable<WebApiResponse> {
    return this.get('TipiCamereOTA/' + oidTipoCamera + '/DeleteListingAirbnb');
  }

  getPagamentoFormView(rq: GetPagamentoFormViewRQ): Observable<GetPagamentoFormViewRS> {
    return this.post('Booking/PagamentoFormView', rq);
  }

  recuperaPrenotazioni(rq: RecuperaPrenotazioniRQ): Observable<RecuperaPrenotazioniRS> {
    return this.post('Portali/RecuperaPrenotazioni', rq);
  }

  confermaPrenotazioniWS(rq: ConfermaPrenotazioniWSRQ): Observable<RecuperaPrenotazioniRS> {
    return this.post('Portali/ConfermaPrenotazioniWS', rq);
  }

  getRisposteSondaggio(oidSondaggio: number): Observable<WebApiResponse> {
    return this.get('Sondaggi/' + oidSondaggio + '/Risposte');
  }

  getSmtpServerViewSelect(rq?: WebApiRequestFilter, addEmptyItem: boolean = true): Observable<WebApiResponseFilter> {
    return this.post('AccountMail/SmtpServer/ViewSelect', new WebApiRequestViewSelect(rq, addEmptyItem));
  }

  getRisorseTariffeNonAttiveServizio(rq: GetRisorseTariffeNonAttiveServizioRQ): Observable<GetRisorseTariffeNonAttiveServizioRS> {
    return this.post('Servizi/GetRisorseTariffeNonAttive', rq);
  }

  associaRisorseTariffeServizio(rq: AssociaRisorseTariffeServizioRQ): Observable<WebApiResponse> {
    return this.post('Servizi/AssociaRisorseTariffe', rq);
  }

  getRisorseNonAttiveSistemazione(rq: GetRisorseNonAttiveSistemazioneRQ): Observable<WebApiResponse> {
    return this.post('Sistemazioni/GetRisorseNonAttive', rq);
  }

  associaRisorseSistemazione(rq: AssociaRisorseSistemazioneRQ): Observable<WebApiResponse> {
    return this.post('Sistemazioni/AssociaRisorse', rq);
  }

  getTariffePianoTariffario(rq: GetTariffePianoTariffarioRQ): Observable<GetTariffePianoTariffarioRS> {
    return this.post('PianiTariffari/GetTariffe', rq);
  }

  associaTariffePianoTariffario(rq: AssociaTariffePianoTariffarioRQ): Observable<WebApiResponse> {
    return this.post('PianiTariffari/AssociaTariffe', rq);
  }

  getContenuti(rq: GetContenutiRQ): Observable<GetContenutiRS> {
    return this.post('Booking/Contenuti', rq);
  }

  eseguiWorkFlows(oidWorkFlow: number): Observable<WebApiResponse> {
    return this.post('Welcome/EseguiWorkFlows', new WelcomeEseguiWorkFlowsRQ(this.sessionService.getCodiceAlbergo(), oidWorkFlow), true, new HttpHeaders({ 'X-Azienda': this.sessionService.getAziendaHotel(), 'X-Key': 'DvT2IV9Awyaq6XUMw7G0ATXwdzA1Wtog' }));
  }

  getGiorniChiusura(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/GiorniChiusura');
  }

  getGiorniChiusuraFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/GiorniChiusura/Filter', rq);
  }

  getTemplateConfigurazionePortale(rq: GetTemplateConfigurazionePortaleRQ): Observable<GetTemplateConfigurazionePortaleRS> {
    return this.post('Portali/GetTemplateConfigurazione', rq);
  }

  inviaEmailPortale(rq: InviaEmailPortaleRQ): Observable<InviaEmailPortaleRS> {
    return this.post('Portali/InviaEmail', rq);
  }

  recuperaPasswordAPI(rq: RecuperaPasswordAPIRQ): Observable<SendMailRS> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/RecuperaPasswordAPI', rq);
  }

  getQuadriGrafici(): Observable<WebApiResponse> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/QuadriGrafici');
  }

  getQuadriGraficiFilter(rq: WebApiRequestFilter): Observable<WebApiResponseFilter> {
    return this.post('Albergo/' + this.sessionService.getOidAlbergo() + '/QuadriGrafici/Filter', rq);
  }

  setQuadroGrafico(rq: QuadroGrafico): Observable<WebApiResponseUpdate> {
    return this.post('QuadriGrafici/Update', rq);
  }

  getQuadroGrafico(oid: number): Observable<WebApiResponse> {
    return this.get('QuadriGrafici/' + oid);
  }

  getPrezzoListinoPrenotazioneAccessoriWelcome(rq: GetPrezzoListinoPrenotazioneAccessoriWelcomeRQ): Observable<GetPrezzoListinoPrenotazioneAccessoriWelcomeRS> {
    return this.post('SmartCloud/GetPrezzoListinoPrenotazioneAccessori', rq);
  }

  getVersioneBookingEngine(rq: GetVersioneBookingEngineRQ): Observable<WebApiResponse> {
    return this.post('Booking/GetVersioneBookingEngine', rq);
  }

  verificaCodicePromozioneBooking(rq: VerificaCodicePromozioneBookingRQ): Observable<WebApiResponse> {
    return this.post('Booking/VerificaCodicePromozione', rq);
  }

  getTipiClienteView(): Observable<TipiClienteViewRS> {
    return this.get('Albergo/' + this.sessionService.getOidAlbergo() + '/TipiClienteView');
  }

  checkVoucher(rq: CheckVoucherRQ): Observable<CheckVoucherRS> {
    return this.post('Booking/CheckVoucher', rq);
  }

  checkDisponibilitaVoucher(rq: CheckDisponibilitaVoucherRQ): Observable<WebApiResponse> {
    return this.post('Booking/CheckDisponibilitaVoucher', rq);
  }

  getVoucherConfig(rq: GetVoucherConfigRQ): Observable<GetVoucherConfigRS> {
    return this.post('Booking/GetVoucherConfig', rq);
  }

  getStampaPrenotazioneFormWelcome(rq: GetStampaPrenotazioneFormWelcomeRQ): Observable<GetStampaPrenotazioneFormWelcomeRS> {
    return this.post('SmartCloud/GetStampaPrenotazioneForm', rq);
  }

  stampaPrenotazioneWelcome(rq: StampaPrenotazioneWelcomeRQ): Observable<StampaPrenotazioneWelcomeRS> {
    return this.post('SmartCloud/StampaPrenotazione', rq);
  }
}